import {
  ActionIcon,
  Avatar,
  Badge,
  Box,
  Button,
  Card,
  Center,
  Divider,
  Grid,
  Group,
  Image,
  Paper,
  ScrollArea,
  SimpleGrid,
  Stack,
  Text,
  TextInput,
  Title, Modal, Textarea, Input, Select, List, ThemeIcon, Tabs, Anchor, Loader
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import {
  IconBell,
  IconBellRinging,
  IconCalendarEvent,
  IconExternalLink,
  IconFileDescription,
  IconGavel,
  IconHistory,
  IconHome,
  IconInfoCircle,
  IconLayoutDashboard,
  IconMessage2,
  IconNotebook,
  IconScale,
  IconSearch,
  IconShield,
  IconUser,
  IconVideo,
  IconShieldLock,
  IconUserCheck,
  IconAlertTriangle,
  IconCheck, IconCrown, IconArrowRight, IconHammer
} from "@tabler/icons-react";

import FilePresentIcon from '@mui/icons-material/FilePresent';
import SearchIcon from '@mui/icons-material/Search';
import GavelIcon from '@mui/icons-material/Gavel';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import DescriptionIcon from '@mui/icons-material/Description'
import DownloadIcon from '@mui/icons-material/Download'
import DashboardIcon from '@mui/icons-material/Dashboard';
import TvIcon from '@mui/icons-material/Tv';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import BalanceIcon from '@mui/icons-material/Balance';
import LinkIcon from '@mui/icons-material/Link';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import LanguageIcon from '@mui/icons-material/Language';
import { useState, useEffect } from "react";
import CdrLogo from "../Newlogo/image.png";
import dayjs from 'dayjs';
import { DatePicker, Empty, message } from 'antd';
import { Userauthcontexthooks } from "../Hooks/Userauthcontexthooks";
// import Newpolicetable from "../Components/Policecomp/Newpolicetable";
import Newfirtable from "../Components/Policecomp/Newfirtable";
import DelhiHighcourt from '../Images/Delhihighcourt.png';
import IndSupremecourt from '../Images/Supremecourt.jpeg';
import Delhidistrictcourts from '../Images/Delhidistrictscourts.png';
import Newnavbar from "../Components/Navbar/Newnavbar";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { useMediaQuery } from '@mantine/hooks';


export default function PremiumHomePage() {
  const { user } = Userauthcontexthooks();
  const isMobile = useMediaQuery('(max-width: 768px)');

  const [activeModal, setActiveModal] = useState(null);
  const [Notificationdate, setNotificationdate] = useState(''); // For Date ALert
  const [selectcourt, setselectcourt] = useState(''); // For Date ALert
  const [selectsubdistcourt, setselectsubdistcourt] = useState('') // For Date ALert
  const [selecthighcourt, setselecthighcourt] = useState('') // For Date ALert
  const [selectcasetype, setselectcasetype] = useState('') // For Date ALert
  const [selectedCourt, setSelectedCourt] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [btnloading, setBtnloading] = useState(false);
  const [Alertinputs, setalertsinputs] = useState({
    courtno: '',
    judgename: '',
    policestation: '',
    clientname: '',
    clientemail: '',
    caseyear: '',
    firsthearingdate: '',
    narration: ''
  })
  const [openedalertdetailsmodal, { open: alertdetailmodal, close: closealertdetailmodeal }] = useDisclosure(false); // For Date Alert how to use Details Modal

  const [Distcourt, setDistcourt] = useState([]); // for VC links
  const [Highcourt, setHighcourt] = useState([]); // for VC links
  const [Supremcourt, setSupremcourt] = useState([]); // for VC links
  const [distsearchTerm, setDistsearchTerm] = useState('');// for VC links
  const [highsearchTerm, setHighsearchTerm] = useState('');// for VC links
  const [supremsearchTerm, setSupremsearchTerm] = useState('');// for VC links
  const [loadinghighcourt, setLoadinghighcourt] = useState(true); // for VC links
  const [loadingsupremcourt, setLoadingsupremcourt] = useState(true);// for VC links

  const [miscfiles, setmiscfiles] = useState([]); // For legal drafts and misc files
  const [loading, setloading] = useState(true);  // For legal drafts and misc files
  const [filesearch, setfilesearch] = useState('');  // For legal drafts and misc files
  const [courtcalenders, setcourtcalenders] = useState([]); // For court calenders

  const [extdata, setextdata] = useState([]); // For External links
  const [loadingextlinks, setLoadingextlinks] = useState(true); // For External links

  const [legaluserprofiles, setlegaluserprofiles] = useState([]); // For legal user profiles.
  const [page, setpage] = useState(1); // for legal user profiles. 
  const [hasMore, sethasMore] = useState(true);// for legal user profiles. 
  const [legalprofilesloading, setlegalprofilesloading] = useState(false);// for legal user profiles. 
  const [selectedProfile, setSelectedProfile] = useState(null); // for legal user profiles. view full details in modal
  const [profileModal, setProfileModal] = useState(false); // for legal user profiles. view full details in modal
  const [userDetails, SetUserDetails] = useState(''); // for getting individual user details to check the profile completion for date alert feature and also to show the details in profile section of navbar.

  const [legalupdates, setLegalUpdates] = useState([]); // for legal updates in home page
  const [legalUpdateModal, setLegalUpdateModal] = useState(false); // for legal updates in home page
  const [selectedLegalUpdate, setSelectedLegalUpdate] = useState(null); // for legal updates in home page

  const OpenLegalUpdateModal = (item) => { // for legal updates in home page
    setSelectedLegalUpdate(item);
    setLegalUpdateModal(true);
  };

  // OPEN PROFILE MODAL
  const OpenProfileDetails = (profile) => {
    setSelectedProfile(profile);
    setProfileModal(true);
  };

  function OpenALertDetailsModal() {
    setActiveModal(null)
    alertdetailmodal();
  }

  const Alertonchange = (e) => {
    const { name, value } = e.target;
    setalertsinputs({ ...Alertinputs, [name]: value })
  }
  const DateonChange = (date) => {
    setNotificationdate(date);
  };

  const services = [
    {
      title: "Date Alert",
      icon: <IconBell size={30} />,
      color: "#3b82f6",
    },
    {
      title: "VC Links",
      icon: <IconVideo size={30} />,
      color: "#06b6d4",
    },
    {
      title: "FIR Details",
      icon: <IconShield size={30} />,
      color: "#10b981",
    },
    {
      title: "Legal Drafts",
      icon: <IconNotebook size={30} />,
      color: "#8b5cf6",
    },
    {
      title: "Court Calendar",
      icon: <IconCalendarEvent size={30} />,
      color: "#f59e0b",
    },
    {
      title: "Display Boards",
      icon: <IconLayoutDashboard size={30} />,
      color: "#ec4899",
    },
    {
      title: "E-Filing",
      icon: <IconFileDescription size={30} />,
      color: "#14b8a6",
    },
    {
      title: "External Links",
      icon: <IconExternalLink size={30} />,
      color: "#6366f1",
    },
  ];


  const SubmitAlert = async () => {
    const { courtno, judgename, policestation, clientname, clientemail, caseyear, firsthearingdate, narration } = Alertinputs;
    if (!courtno || !judgename || !policestation || !clientname || !clientemail || !caseyear || !firsthearingdate) {
      message.error('Please fill all the fields');
      return
    }
    if (!Notificationdate) {
      message.error('Please select notification date');
      return
    }
    if (!selectcourt) {
      message.error('Please select court');
      return
    }
    if (!selectcasetype) {
      message.error('Please select case type');
      return
    }
    if (selectcourt === 'Dist. court' && !selectsubdistcourt) {
      message.error('Please enter district court');
      return
    }
    if (selectcourt === 'High court' && !selecthighcourt) {
      message.error('Please enter high court');
      return
    }
    const notificationdate = dayjs(Notificationdate).format('DD-MM-YYYY'); // for input.
    setBtnloading(true);
    // setalertsinputs({ ...Alertinputs, courtname: selectcourt });

    const res = await fetch('https://cdr-backend.onrender.com/create/alert', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${user}`
      },
      body: JSON.stringify({ selectcourt, selectcasetype, selectsubdistcourt, selecthighcourt, courtno, judgename, policestation, clientname, clientemail, caseyear, firsthearingdate, notificationdate, narration })
    });
    //message.loading('Please wait! Your alert saving in progress...', 3)
    if (res.status === 201) {
      // message.info('You can check your alert in the alert history section', 4);
      message.success('Alert created successfully');
      setActiveModal(null);
      setalertsinputs({
        courtno: '',
        courtname: '',
        policestation: '',
        clientname: '',
        clientemail: '',
        caseyear: '',
        firsthearingdate: '',
        narration: ''
      })
      setselectcourt('');
      setselectsubdistcourt('');
      setselectcasetype('');
      setNotificationdate('');
      //setLoading({ ...loading, btnloading: false });
      setBtnloading(false);
      return
    }
    // } else if (res.status === 401) {
    //   api['error']({
    //     message: 'Please complete your profile',
    //     description:
    //       'Add your Email ID or Mobile No to your profile to create alert',
    //   });
    //   setBtnloading(false);
    //   return
    // }
    // else if (res.status === 400) {
    //   message.error('Error occurred while creating alert. Please try again');
    //   setBtnloading(false);
    //   return
    // }
    else {
      message.error('Something went wrong');
      setBtnloading(false);
      return
    }
  }
  const v2_getUserprofiles = async (currentPage = 1) => {

    if (legalprofilesloading || !hasMore) return;

    try {

      setlegalprofilesloading(true);

      const res = await fetch(
        `https://cdr-backend.onrender.com/v2/get-users-profiles?page=${currentPage}&limit=10`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user}`
          }
        }
      );

      const data = await res.json();

      if (res.status === 200) {

        setlegaluserprofiles((prev) => {

          // REMOVE DUPLICATE USERS
          const merged = [...prev, ...data.userProfiles];

          const uniqueUsers = merged.filter(
            (item, index, self) =>
              index === self.findIndex((t) => t._id === item._id)
          );

          return uniqueUsers;
        });

        sethasMore(data.hasMore);

        setpage(currentPage);
      }

    } catch (error) {
      console.log(error);
    } finally {
      setlegalprofilesloading(false);
    }
  };

  useEffect(() => {
    const v2_getUserprofiles = async (currentPage = 1) => {

      if (legalprofilesloading || !hasMore) return;

      try {

        setlegalprofilesloading(true);

        const res = await fetch(
          `https://cdr-backend.onrender.com/v2/get-users-profiles?page=${currentPage}&limit=10`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${user}`
            }
          }
        );

        const data = await res.json();

        if (res.status === 200) {

          setlegaluserprofiles((prev) => {

            // REMOVE DUPLICATE USERS
            const merged = [...prev, ...data.userProfiles];

            const uniqueUsers = merged.filter(
              (item, index, self) =>
                index === self.findIndex((t) => t._id === item._id)
            );

            return uniqueUsers;
          });

          sethasMore(data.hasMore);

          setpage(currentPage);
        }

      } catch (error) {
        console.log(error);
      } finally {
        setlegalprofilesloading(false);
      }
    };
    if (user) {
      v2_getUserprofiles(1);
    }

  }, [user, hasMore, legalprofilesloading]);
  useEffect(() => { // for VC links and External links
    if (user) {
      const GetDistCourt = async () => {
        const res = await fetch('https://cdr-backend.onrender.com/get/vclinks/getdistcourt', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user}`
          }
        });

        const data = await res.json();
        //console.log(data);

        if (res.status === 200) {
          setDistcourt(data.Distcourt);
          // setLoading({ ...loading, distcourt: false });
          // setLoadingdistcourt(false);
          return
        }
      }
      const GetHighCourt = async () => {
        const res = await fetch('https://cdr-backend.onrender.com/get/vclinks/gethighcourt', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user}`
          }
        });

        const data = await res.json();
        // console.log(data);

        if (res.status === 200) {
          setHighcourt(data.Highcourt);
          //setLoading({ ...loading, highcourt: false });
          setLoadinghighcourt(false);
          return
        }
      }
      const GetSupremeCourt = async () => {
        const res = await fetch('https://cdr-backend.onrender.com/get/vclinks/getsupremecourt', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user}`
          }
        });

        const data = await res.json();
        if (res.status === 200) {
          setSupremcourt(data.Supremecourt);
          //setLoading({ ...loading, supremcourt: false });
          setLoadingsupremcourt(false);
          return
        }
      }
      const GetExtLinks = async () => {
        const res = await fetch('https://cdr-backend.onrender.com/get/externallinks', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user}`
          }

        });
        const data = await res.json();
        if (res.status === 200) {
          setextdata(data.ExtlinksOBJ);
          setLoadingextlinks(false);
        }
      }

      GetDistCourt();
      GetHighCourt();
      GetSupremeCourt();
      GetExtLinks();
    }
  }, [user])
  useEffect(() => { // for legal drafts and misc files
    if (user) {
      const GetALLMiscForms = async () => {
        const res = await fetch('https://cdr-backend.onrender.com/get/miscforms', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user}`
          }
        })
        const data = await res.json();
        if (res.status === 200) {
          setmiscfiles(data.MiscFormsOBJ);
          setloading(false);
          return
        }
      }
      GetALLMiscForms();
    }

  }, [loading, user])
  useEffect(() => { // for court calenders
    if (user) {
      const GetALLCourtCalenders = async () => {
        const res = await fetch('https://cdr-backend.onrender.com/get/courtcalenders', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user}`
          }
        })
        const data = await res.json();
        if (res.status === 200) {
          setcourtcalenders(data.CourtcalendrOBJ);
          setloading(false);
          return
        }
      }
      GetALLCourtCalenders();
    }

  }, [loading, user])
  useEffect(() => { // get individual user details
    const GetIndividualUser = async () => {
      const res = await fetch("https://cdr-backend.onrender.com/get/user-details", {
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
          'Authorization': `Bearer ${user}`
        }
      });

      const Result = await res.json();
      if (res.status === 200) {
        SetUserDetails(Result.ExistingUser);
        return
      } else {
        return;
      }
    }
    if (user) {
      GetIndividualUser();
    }
  }, [user])
  useEffect(() => { // get legal updates latest 2
    const Getlegalupdates_latest2 = async () => {
      const res = await fetch("https://cdr-backend.onrender.com/v2/get/legal-updates", {
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
          'Authorization': `Bearer ${user}`
        }
      });

      const Result = await res.json();
      if (res.status === 200) {
        setLegalUpdates(Result.updates);
        return
      } else {
        return;
      }
    }
    if (user) {
      Getlegalupdates_latest2();
    }
  }, [user])
  return (
    <>
      <Modal // how to use date alert 
        opened={openedalertdetailsmodal}
        onClose={closealertdetailmodeal}
        centered
        size="lg"
        radius="30px"
        overlayProps={{
          backgroundOpacity: 0.65,
          blur: 8,
        }}
        styles={{
          header: {
            background:
              "linear-gradient(135deg, #0f172a 0%, #111827 100%)",
            borderBottom: "1px solid rgba(255,255,255,0.08)",
            padding: "18px 24px",
          },
          title: {
            color: "white",
            fontWeight: 800,
            fontSize: "20px",
          },
          content: {
            background:
              "linear-gradient(180deg, #111827 0%, #0f172a 100%)",
            border: "1px solid rgba(255,255,255,0.08)",
            backdropFilter: "blur(20px)",
            //overflow: "hidden",
          },
          body: {
            padding: "24px",
          },
        }}
        title="🛡️ Date Alert User Guide"
      >
        <Stack gap="lg">

          {/* TOP INFO CARD */}
          <Paper
            radius="xl"
            p="lg"
            style={{
              background: "rgba(59,130,246,0.12)",
              border: "1px solid rgba(96,165,250,0.25)",
            }}
          >
            <Group align="flex-start" wrap="nowrap">
              <ThemeIcon
                size={42}
                radius="xl"
                variant="gradient"
                gradient={{ from: "blue", to: "cyan" }}
              >
                <IconBellRinging size={22} />
              </ThemeIcon>

              <Box>
                <Text fw={700} c="white" size="lg">
                  How Date Alert Works
                </Text>

                <Text c="#cbd5e1" size="sm" mt={4}>
                  Court Date Reminder automatically sends two alerts
                  before your hearing schedule.
                </Text>
              </Box>
            </Group>
          </Paper>

          {/* PROFILE SECTION */}
          <Paper
            radius="xl"
            p="lg"
            style={{
              background: "rgba(255,255,255,0.04)",
              border: "1px solid rgba(255,255,255,0.08)",
            }}
          >
            <Group mb="md">
              <ThemeIcon
                radius="xl"
                size={38}
                color="green"
                variant="light"
              >
                <IconUserCheck size={20} />
              </ThemeIcon>

              <Title order={4} c="white">
                Complete Your Profile
              </Title>
            </Group>

            <List
              spacing="sm"
              withPadding
              styles={{
                itemLabel: {
                  color: "#cbd5e1",
                },
              }}
              icon={
                <ThemeIcon color="green" radius="xl" size={20}>
                  <IconCheck size={12} />
                </ThemeIcon>
              }
            >
              <List.Item>
                If <strong>Edit Profile</strong> appears in avatar,
                your account is incomplete.
              </List.Item>

              <List.Item>
                Complete Name, Mobile Number, Email & Advocate details.
              </List.Item>

              <List.Item>
                Date Alert feature only works for completed accounts.
              </List.Item>
            </List>
          </Paper>

          {/* ALERT SYSTEM */}
          <Paper
            radius="xl"
            p="lg"
            style={{
              background: "rgba(255,255,255,0.04)",
              border: "1px solid rgba(255,255,255,0.08)",
            }}
          >
            <Group mb="md">
              <ThemeIcon
                radius="xl"
                size={38}
                variant="gradient"
                gradient={{ from: "yellow", to: "orange" }}
              >
                <IconCalendarEvent size={20} />
              </ThemeIcon>

              <Title order={4} c="white">
                Alert Schedule System
              </Title>
            </Group>

            <Text c="#cbd5e1" size="sm" mb="sm">
              After creating an alert, you receive:
            </Text>

            <Stack gap="sm">
              <Paper
                radius="lg"
                p="sm"
                style={{
                  background: "rgba(59,130,246,0.12)",
                  border: "1px solid rgba(59,130,246,0.2)",
                }}
              >
                <Group>
                  <ThemeIcon color="blue" radius="xl">
                    <IconBell size={16} />
                  </ThemeIcon>

                  <Box>
                    <Text c="white" fw={700}>
                      First Alert
                    </Text>

                    <Text c="#cbd5e1" size="sm">
                      8:00 PM — One day before hearing date
                    </Text>
                  </Box>
                </Group>
              </Paper>

              <Paper
                radius="lg"
                p="sm"
                style={{
                  background: "rgba(34,197,94,0.12)",
                  border: "1px solid rgba(34,197,94,0.2)",
                }}
              >
                <Group>
                  <ThemeIcon color="green" radius="xl">
                    <IconBellRinging size={16} />
                  </ThemeIcon>

                  <Box>
                    <Text c="white" fw={700}>
                      Second Alert
                    </Text>

                    <Text c="#cbd5e1" size="sm">
                      8:00 AM — On hearing date
                    </Text>
                  </Box>
                </Group>
              </Paper>
            </Stack>
          </Paper>

          {/* NOTIFICATION PERMISSION */}
          <Paper
            radius="xl"
            p="lg"
            style={{
              background: "rgba(255,255,255,0.04)",
              border: "1px solid rgba(255,255,255,0.08)",
            }}
          >
            <Group mb="md">
              <ThemeIcon
                radius="xl"
                size={38}
                variant="gradient"
                gradient={{ from: "violet", to: "grape" }}
              >
                <IconShieldLock size={20} />
              </ThemeIcon>

              <Title order={4} c="white">
                Enable Notifications
              </Title>
            </Group>

            <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">

              {/* ANDROID */}
              <Paper
                radius="lg"
                p="md"
                style={{
                  background: "rgba(255,255,255,0.03)",
                  border: "1px solid rgba(255,255,255,0.06)",
                }}
              >
                <Text fw={700} c="white" mb="sm">
                  📱 Android App
                </Text>

                <List
                  spacing="xs"
                  withPadding
                  styles={{
                    itemLabel: {
                      color: "#cbd5e1",
                      fontSize: "14px",
                    },
                  }}
                >
                  <List.Item>
                    Allow notification permission on app launch.
                  </List.Item>

                  <List.Item>
                    Enable app notifications from phone settings.
                  </List.Item>

                  <List.Item>
                    Disable battery restriction for CDR app.
                  </List.Item>
                </List>
              </Paper>

              {/* WEB */}
              <Paper
                radius="lg"
                p="md"
                style={{
                  background: "rgba(255,255,255,0.03)",
                  border: "1px solid rgba(255,255,255,0.06)",
                }}
              >
                <Text fw={700} c="white" mb="sm">
                  💻 Web Browser
                </Text>

                <List
                  spacing="xs"
                  withPadding
                  styles={{
                    itemLabel: {
                      color: "#cbd5e1",
                      fontSize: "14px",
                    },
                  }}
                >
                  <List.Item>
                    Click “Allow” when notification popup appears.
                  </List.Item>

                  <List.Item>
                    Enable browser notifications manually if blocked.
                  </List.Item>

                  <List.Item>
                    Keep browser background notifications enabled.
                  </List.Item>
                </List>
              </Paper>
            </SimpleGrid>
          </Paper>

          {/* WARNING CARD */}
          <Paper
            radius="xl"
            p="lg"
            style={{
              background: "rgba(239,68,68,0.12)",
              border: "1px solid rgba(239,68,68,0.25)",
            }}
          >
            <Group align="flex-start" wrap="nowrap">
              <ThemeIcon color="red" radius="xl" size={40}>
                <IconAlertTriangle size={22} />
              </ThemeIcon>

              <Box>
                <Text c="white" fw={700}>
                  Important Notes
                </Text>

                <List
                  mt="sm"
                  spacing="xs"
                  withPadding
                  styles={{
                    itemLabel: {
                      color: "#fecaca",
                    },
                  }}
                >
                  <List.Item>
                    Keep internet connection active.
                  </List.Item>

                  <List.Item>
                    Do not force close the application.
                  </List.Item>

                  <List.Item>
                    Make sure Do Not Disturb mode is disabled.
                  </List.Item>

                  <List.Item>
                    Web users should allow background notifications.
                  </List.Item>
                </List>
              </Box>
            </Group>
          </Paper>

          {/* FOOTER */}
          <Text
            ta="center"
            size="sm"
            c="#94a3b8"
            mt={4}
          >
            Court Date Reminder helps legal professionals manage
            hearings efficiently with real-time alerts.
          </Text>
        </Stack>
      </Modal>
      <Modal // For Date Alert
        opened={activeModal === "Date Alert"}
        onClose={() => setActiveModal(null)}
        centered
        size="lg"
        radius="30px"
        overlayProps={{
          blur: 10,
          backgroundOpacity: 0.55,
        }}
        styles={{
          content: {
            background:
              "linear-gradient(135deg, rgba(15,23,42,0.96), rgba(30,41,59,0.95))",
            border: "1px solid rgba(255,255,255,0.08)",
            backdropFilter: "blur(20px)",
            boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
          },
          header: {
            background:
              "linear-gradient(135deg, #0f172a 0%, #111827 100%)",
            // background: "transparent",
            borderBottom: "1px solid rgba(255,255,255,0.08)",
          },
          title: {
            color: "white",
            fontWeight: 800,
            fontSize: 22,
          },
          close: {
            color: "white",
          },
          body: {
            paddingTop: 20,
          },
        }}
        title="⚖️ Court Date Alert"
      >
        <Stack gap="md">
          {/* INFO CARD */}
          <Paper
            radius="xl"
            p="md"
            style={{
              background: "rgba(59,130,246,0.12)",
              border: "1px solid rgba(96,165,250,0.25)",
            }}
          >
            <Group justify="space-between">
              <Box>
                <Text fw={700} c="white" size="sm">
                  Smart Court Notification System
                </Text>

                <Text c="#cbd5e1" size="xs" mt={4}>
                  Create reminders for hearings, client updates & legal tracking.
                </Text>
              </Box>

              <Button
                size="xs"
                radius="xl"
                variant="gradient"
                gradient={{ from: "blue", to: "cyan" }}
                onClick={OpenALertDetailsModal}
              >
                User Guide
              </Button>
            </Group>
          </Paper>

          {/* COURT SELECT */}
          <Select
            label="Select Court"
            placeholder="Choose Court"
            data={["Supreme court", "High court", "Dist. court"]}
            value={selectcourt}
            onChange={(value) => setselectcourt(value)}
            withAsterisk
            radius="xl"
            size="md"
            styles={{
              label: {
                color: "#e2e8f0",
                marginBottom: 6,
                fontWeight: 600,
              },
              input: {
                background: "rgba(255,255,255,0.05)",
                border: "1px solid rgba(255,255,255,0.1)",
                color: "white",
                height: 52,
              },
              dropdown: {
                // background: "#111827",
                border: "1px solid rgba(255,255,255,0.1)",
              },
            }}
          />

          {/* DISTRICT COURT */}
          {selectcourt === "Dist. court" && (
            <>
              <TextInput
                radius="xl"
                label={'District Court'}
                withAsterisk
                placeholder={'District Court'}
                // name={field.name}
                value={selectsubdistcourt}
                onChange={(e) => setselectsubdistcourt(e.target.value)}
                size="md"
                styles={{
                  label: {
                    color: "#e2e8f0",
                    marginBottom: 6,
                    fontWeight: 600,
                  },
                  input: {
                    background: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    color: "white",
                    height: 52,
                  },
                }}
              />
              {/* <Select
                label="Select District Court"
                placeholder="Choose District Court"
                data={[
                  "Tis Hazari courts",
                  "Rouse Avenue courts",
                  "Karkardooma courts",
                  "Patiala House courts",
                  "Rohini courts",
                  "Dwarka courts",
                  "Saket courts",
                ]}
                value={selectsubdistcourt}
                onChange={(value) => setselectsubdistcourt(value)}
                withAsterisk
                radius="xl"
                searchable
                size="md"
                styles={{
                  label: {
                    color: "#e2e8f0",
                    marginBottom: 6,
                    fontWeight: 600,
                  },
                  input: {
                    background: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    color: "white",
                    height: 52,
                  },
                }}
              /> */}

            </>
          )}
          {selectcourt === "High court" && (
            <>
              <TextInput
                radius="xl"
                label={'High Court'}
                withAsterisk
                placeholder={'High Court'}
                // name={field.name}
                value={selecthighcourt}
                onChange={(e) => setselecthighcourt(e.target.value)}
                size="md"
                styles={{
                  label: {
                    color: "#e2e8f0",
                    marginBottom: 6,
                    fontWeight: 600,
                  },
                  input: {
                    background: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    color: "white",
                    height: 52,
                  },
                }}
              />
            </>
          )}

          {/* CASE TYPE */}
          {(selectcourt === "Dist. court" ||
            selectcourt === "High court" ||
            selectcourt === "Supreme court") && (
              <Select
                label="Select Case Type"
                placeholder="Choose Case Type"
                data={
                  selectcourt === "Dist. court"
                    ? ['ARBTN- ARBRITRATION CASES', 'BAIL MATTERS- BAIL CASE TYPE', 'CA- CRIMINAL APPEAL', 'CBI- CBI', 'CC- CORRUPTION CASES', 'CC NI ACT- COMPLAINT CASE 138 NI ACT', 'CIV DJ- CIVIL SUIT FOR DJ AND ADJ', 'CIV SCJ- CIVIL SUIT FOR CIVIL JUDGE', 'CLO_R- CLOSURE REPORT', 'COUNTER CLAIM', 'COURT COMPLAINT', 'CR- COPY RIGHT', 'CR CASES- CRIMINAL CASE', 'CR REV- CRIMINAL REVISION', 'CT CASES- COMPLAINT CASES', 'DE- DEPARTMENTAL ENQUIRY', 'DE CRL- DEPARTMENTAL ENQUIRY CRIMINAL', 'E.P.- ELECTION PETITTION', 'ESIC- EMPLOYEE STATE INSURANCE ACT', 'EX- EXECUTION', 'EX CRL- EXECUTION', 'FACT F- FACT FINDING ENQUIRY', 'FSAT- FOOD SAFTY APPELLATE TRIBUNAL', 'GP- GUARDIAN CASES', 'HINDU ADP.- HINDU ADOPTATION MAINT. ACT', 'HMA- HINDU MARRIAGE ACT', 'HTA- HOUSE TAX APPEAL', 'IDA- DEVORCE ACT', 'INSOLVENCY- INSOLVENCY CASE', 'ITA- INDUSTRIAL TRIBUNAL', 'LAC- LAND ACQ. ACT', 'LC- LABOUR COURT', 'LCA- LABOUR COURT APPLICATION', 'LIR- LABOUR/IND. TRIB REF MATTER', 'M- MISC. CASES', 'M.A.C.T- M.A.C.T', 'MACT CRL- MACT CRIMINAL', 'MC- MAHILA COURT', 'MCA DJ- MISC. CIVIL APPEAL FOR DJ ADJ', 'MCA SCJ- MISC. APPEAL FOR CJ', 'MCD APPL- MCA APPEAL', 'M-EX- MISC. EXECUTION', 'MGP- MISC. GUARDIANSHIP CASES', 'MHA- MENTAL HEALTH CASES', 'MISC DJ- MISC. CASES FOR DJ AND DJ', 'MISC SCJ- MISC. CASES FOR CJ', 'MPC- MISC. PROBATE CASES', 'MUSLIM LAW- MUSLIM LAW DELHI WAQF BOARD', 'OP- APPROVAL', 'PC- PROBATE/LETTER', 'PPA- PUBLIC PREMISES ACT', 'RCA DJ- REG. CIVIL APPEAL FOR DJ ADJ', 'RC ARC- RENT CONTROLLER ADDL. R.C.', 'RCA SCJ- CIVIL APPEAL FOR CJ', 'RCT ARCT- RENT CNTRL TRIBUNAL ADDL. RCT', 'REC. CASES- RECEIVERSHIP CASES', 'REVOCATION', 'RP- REVISION PETITION', 'RTI APPEAL- RIGHT TO INFORMATION ACT. APPL.', 'SC- SESSIONS CASE', 'SMA- SPECIAL MARRIAGE ACT', 'SMALL CAUSE- SMALL CAUSE COURT', 'SUCC. COURT- SUCCESSION COURT', 'TM- TRADE MARKS', 'T.P.(C)- TRANSFER APPLICATION', 'T.P.(CRL)- TRANSFER APPLICATION (CRL)', 'TRAFFIC CHALLAN', 'OTHER(S)']
                    : selectcourt === "High court"
                      ? ['ADMIN. REPORT', 'ARB. A.', 'ARB.A. (COMM.)', 'ARB.P.', 'BAIL APPLN', 'CA', 'CA (COMM.IPD-CR)', 'C.A. (COMM.IPD-GI)', 'C.A. (COMM.IPD.-PAT)', 'C.A. (COMM.IPD-PV)', 'C.A. (COMM.IPD-TM)', 'CAVEAT(CO.)', 'CC(ARB.)', 'CCP(CO.)', 'CCP(REF)', 'CEAC', 'CEAR', 'CHAT.A.C.', 'CHAT.A.REF.', 'CMI', 'CM(M)', 'CM(M)-IPD', 'C.O.', 'CO.APP.', 'CO.APPL.(C)', 'CO.APPL.(M)', 'C.O.A.(SB)', 'C.O.(COMM.IPD-CR)', 'C.O.(COMM.IPD-GI)', 'C.O.(COMM.IPD-PAT)', 'C.O.(COMM.IPD-TM)', 'CO.EX.', 'CONT.APP.(C)', 'CONT.CAS(C)', 'CONT.CAS.(CRL)', 'CO.P.E.T.', 'C.REF.(O)', 'CRL.A.', 'CRL.L.P.', 'CRL.M.C.', 'CRL.M.(CO.)', 'CRL.M.I', 'CRL.O.', 'CRL.O.(CO.)', 'CRL.REF.', 'CRL.REV.P.', 'CRL.REVP.(MAT.)', 'CRL.REV.P.(NDPS)', 'CRL.REVP.(NI)', 'C.R.P.', 'CRP-IPD', 'C.RULE', 'CS(COMM)', 'CS(OS)', 'CS(OS)GP', 'CUSAA', 'CUS.A.C.', 'CUS.A.R.', 'CUSTOM A.', 'DEATH SENTENCE REF.', 'DEMO', 'EDC', 'EDR', 'EFA(COMM)', 'EFA(OS)', 'EFA(OS) (COMM)', 'EFA(OS)(IPD)', 'EL.PET.', 'ETR', 'EX.F.A.', 'EX.P.', 'EX.S.A', 'FAO', 'FAO(COMM)', 'FAO-IPD', 'FAO(OS)', 'FAO(OS) (COMM)', 'FAO(OS) (IPD)', 'GCAC', 'GCAR', 'GTA', 'GTC', 'GTR', 'I.A.', 'I.P.A.', 'ITA', 'ITC', 'ITR', 'ITSA', 'LA.APP.', 'LPA', 'MAC.APP', 'MAT', 'MAT.APP.', 'MAT.APP.(F.C.)', 'MAT.CASE', 'MAT.REF.', 'MISC. APPEAL(PMLA)', 'OA', 'OCJA', 'O.M.P.', 'O.M.P. (COMM)', 'OMP (CONT.)', 'O.M.P.(E) (COMM.)', 'O.M.P.(I)', 'O.M.P(J) (COMM.)', 'O.M.P.(MISC.)', 'O.M.P.(MISC.)(COMM.)', 'O.M.P.(T)', 'O.M.P.(T)(COMM)', 'O.REF.', 'RC.REV.', 'RC.S.A.', 'RERA APPEAL', 'REVIEW PET.', 'RFA', 'RFA(COMM)', 'RFA-IPD', 'RFA(OS)', 'RFA(OS)(COMM)', 'RF(OS)(IPD)', 'RSA', 'SCA', 'SDR', 'SERTA', 'ST.APPL.', 'STC', 'ST.REF.', 'SUR.T.REF.', 'TEST.CAS.', 'TR.P.(C)', 'TR.P.(C.)', 'TR.P.(CRL.)', 'VAT APPEAL', 'W.P.(C)', 'W.P.(C)-IPD', 'WP(C)(IPD)', 'W.P.(CRL)', 'WTA', 'WTC', 'WTR', 'OTHER(S)']
                      : ['SPECIAL LEAVE PETITION (CIVIL)', 'SPECIAL LEAVE PETITION (CRIMMINAL)', 'CIVIL APPEAL', 'CRIMINAL APPEAL', 'WRIT PETITION (CIVIL)', 'WRIT PETITION (CRIMINAL)', 'TRANSFER PETITION (CIVIL)', 'TRANSFER PETITION (CRIMINAL)', 'REVIEW PETITION (CIVIL)', 'REVIEW PETITION (CRIMINAL)', 'TRANSFERRED CASE (CIVIL)', 'TRANSFERED CASE (CRIMINAL)', 'SPECIAL LEAVE TO PETITION (CIVIL)', 'SPECIAL LEAVE TO PETITION (CRIMINAL)', 'WRIT TO PETITION (CIVIL)', 'WRIT TO PETITION (CRIMINAL)', 'ORIGINAL SUIT', 'DEATH REFERENCE CASE', 'CONTEMPT PETITION (CIVIL)', 'CONTEMPT PETITION (CRIMINAL)', 'TAX REFERENCE CASE', 'SPECIAL REFERENCE CASE', 'ELECTION PETITION (CIVIL)', 'ARBITRATION PETITION', 'CURATIVE PETITION (CIVIL)', 'CURATIVE PETITION (CRL)', 'REF. U/A 317(1)', 'MOTION (CRL)', 'DIARYNO AND DIARYYR', 'SUO MOTO WRIT PETITION (CIVIL)', 'SUO MOTO WRIT PETITION (CRIMINAL)', 'SUO MOTO CONTEMPT PETITION (CIVIL)', 'SUO MOTO CONTEMPT PETITION (CRIMINAL)', 'REF. U/S 14 RTI', 'REF. U/S 17 RTI', 'MISC. APPLICATION', 'SUO MOTO TRANSFER PETITION (CIVIL)', 'SUO MOTO TRANSFER PETITION (CRIMINAL)', 'OTHER(S)']
                }
                value={selectcasetype}
                onChange={(value) => setselectcasetype(value)}
                searchable
                withAsterisk
                radius="xl"
                size="md"
                styles={{
                  label: {
                    color: "#e2e8f0",
                    marginBottom: 6,
                    fontWeight: 600,
                  },
                  input: {
                    background: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    color: "white",
                    height: 52,
                  },
                }}
              />
            )}

          {/* INPUTS */}
          {[
            {
              label: "Court No.",
              name: "courtno",
              placeholder: "Enter Court Number",
            },
            {
              label: "Judge Name",
              name: "judgename",
              placeholder: "Enter Judge Name",
            },
            {
              label: "Police Station",
              name: "policestation",
              placeholder: "Enter Police Station",
            },
            {
              label: "Client Name",
              name: "clientname",
              placeholder: "Enter Client Name",
            },
            {
              label: "Client Email",
              name: "clientemail",
              placeholder: "Enter Client Email",
            },
            {
              label: "Case Year",
              name: "caseyear",
              placeholder: "Enter Case Year",
            },
            {
              label: "First Hearing Date",
              name: "firsthearingdate",
              placeholder: "DD-MM-YYYY",
            },
          ].map((field, index) => (
            <TextInput
              key={index}
              radius="xl"
              label={field.label}
              withAsterisk
              placeholder={field.placeholder}
              name={field.name}
              value={Alertinputs[field.name]}
              onChange={Alertonchange}
              size="md"
              styles={{
                label: {
                  color: "#e2e8f0",
                  marginBottom: 6,
                  fontWeight: 600,
                },
                input: {
                  background: "rgba(255,255,255,0.05)",
                  border: "1px solid rgba(255,255,255,0.1)",
                  color: "white",
                  height: 52,
                },
              }}
            />
          ))}

          {/* AUTO COURT NAME */}
          <TextInput
            radius="xl"
            label="Court Name"
            value={selectcourt}
            disabled
            size="md"
            styles={{
              label: {
                color: "#e2e8f0",
                marginBottom: 6,
                fontWeight: 600,
              },
              input: {
                background: "rgba(255,255,255,0.03)",
                border: "1px solid rgba(255,255,255,0.08)",
                color: "#94a3b8",
                height: 52,
              },
            }}
          />

          {/* DATE PICKER */}
          <Input.Wrapper
            label="Select Notification Date"
            withAsterisk
            styles={{
              label: {
                color: "#e2e8f0",
                marginBottom: 8,
                fontWeight: 600,
              },
            }}
          >
            <DatePicker
              value={Notificationdate}
              onChange={DateonChange}
              name="notificationdate"
              radius="xl"
              size="md"
              styles={{
                input: {
                  background: "rgba(255,255,255,0.05)",
                  border: "1px solid rgba(255,255,255,0.1)",
                  color: "white",
                  height: 52,
                },

              }}
            />
          </Input.Wrapper>

          {/* NARRATION */}
          <Textarea
            label="Narration"
            placeholder="Write case narration..."
            autosize
            minRows={4}
            radius="xl"
            name="narration"
            value={Alertinputs.narration}
            onChange={Alertonchange}
            styles={{
              label: {
                color: "#e2e8f0",
                marginBottom: 6,
                fontWeight: 600,
              },
              input: {
                background: "rgba(255,255,255,0.05)",
                border: "1px solid rgba(255,255,255,0.1)",
                color: "white",
              },
            }}
          />

          {/* SUBMIT BUTTON */}
          <Button
            fullWidth
            radius="xl"
            size="lg"
            mt="sm"
            loading={btnloading}
            disabled={btnloading}
            onClick={SubmitAlert}
            variant="gradient"
            gradient={{ from: "blue", to: "cyan", deg: 90 }}
            style={{
              height: 56,
              fontWeight: 700,
              fontSize: 16,
              boxShadow: "0 10px 30px rgba(59,130,246,0.35)",
            }}
          >
            Create Court Alert
          </Button>
        </Stack>
      </Modal>
      <Modal // for VC links
        opened={activeModal === "VC Links"}
        onClose={() => setActiveModal(null)}
        title={
          <Group gap="sm">
            <ThemeIcon
              size={38}
              radius="xl"
              variant="gradient"
              gradient={{ from: "indigo", to: "cyan" }}
            >
              <IconVideo size={20} />
            </ThemeIcon>

            <Box>
              <Text fw={700} size="lg" c="white">
                Virtual Court Links
              </Text>
              <Text size="xs" c="dimmed">
                Access VC rooms, staff details & official court contacts
              </Text>
            </Box>
          </Group>
        }
        centered
        size="xl"
        radius="28px"
        overlayProps={{
          blur: 8,
          backgroundOpacity: 0.55,
        }}
        styles={{
          header: {
            background: "rgba(15,23,42,0.95)",
            borderBottom: "1px solid rgba(255,255,255,0.08)",
          },
          body: {
            background:
              "linear-gradient(135deg, #0f172a 0%, #111827 45%, #1e293b 100%)",
            padding: 20,
          },
          title: {
            width: "100%",
          },
          content: {
            border: "1px solid rgba(255,255,255,0.08)",
            // overflow: "hidden",
            backdropFilter: "blur(20px)",
          },
        }}
      >
        <Tabs
          defaultValue="disc"
          radius="xl"
          variant="pills"
          color="blue"
          styles={{
            tab: {
              border: "1px solid rgba(255,255,255,0.08)",
              color: "#cbd5e1",
            },
          }}
        >
          <Tabs.List grow mb="lg">
            <Tabs.Tab
              value="disc"
              leftSection={<IconHammer size={16} />}
            >
              District Court
            </Tabs.Tab>

            <Tabs.Tab
              value="high"
              leftSection={<IconScale size={16} />}
            >
              High Court
            </Tabs.Tab>

            <Tabs.Tab
              value="suprem"
              leftSection={<IconCrown size={16} />}
            >
              Supreme Court
            </Tabs.Tab>
          </Tabs.List>

          {/* ================= DISTRICT COURT ================= */}

          <Tabs.Panel value="disc">
            <Paper
              radius="24px"
              p="md"
              mb="lg"
              style={{
                background: "rgba(255,255,255,0.05)",
                border: "1px solid rgba(255,255,255,0.08)",
                backdropFilter: "blur(15px)",
              }}
            >
              <TextInput
                radius="xl"
                size="md"
                placeholder="Search judge, room no, VC link, staff..."
                value={distsearchTerm}
                onChange={(e) =>
                  setDistsearchTerm(e.currentTarget.value)
                }
                leftSection={<IconSearch size={16} />}
                styles={{
                  input: {
                    background: "rgba(255,255,255,0.06)",
                    border: "1px solid rgba(255,255,255,0.08)",
                    color: "white",
                    height: 52,
                  },
                }}
              />
            </Paper>

            {/* COURTS */}
            {!selectedCourt && (
              <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
                {Array.from(
                  new Set(
                    Distcourt.map((item) => item.selectsubdistcourt)
                  )
                ).map((court, index) => (
                  <Paper
                    key={index}
                    radius="24px"
                    p="lg"
                    onClick={() => setSelectedCourt(court)}
                    style={{
                      cursor: "pointer",
                      background: "rgba(255,255,255,0.05)",
                      border: "1px solid rgba(255,255,255,0.08)",
                      transition: "0.3s",
                    }}
                  >
                    <Group>
                      <ThemeIcon
                        size={46}
                        radius="xl"
                        variant="gradient"
                        gradient={{ from: "blue", to: "cyan" }}
                      >
                        <IconHammer size={22} />
                      </ThemeIcon>

                      <Box>
                        <Text fw={700} c="white">
                          {court}
                        </Text>

                        <Text size="xs" c="dimmed">
                          Open VC Details
                        </Text>
                      </Box>
                    </Group>
                  </Paper>
                ))}
              </SimpleGrid>
            )}

            {/* DISTRICTS */}
            {selectedCourt && !selectedDistrict && (
              <>
                <Button
                  mb="md"
                  radius="xl"
                  variant="light"
                  color="gray"
                  onClick={() => setSelectedCourt(null)}
                >
                  ← Back to Courts
                </Button>

                <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
                  {Array.from(
                    new Set(
                      Distcourt.filter(
                        (item) =>
                          item.selectsubdistcourt === selectedCourt
                      ).map((item) => item.selectdist)
                    )
                  ).map((district, index) => (
                    <Paper
                      key={index}
                      radius="24px"
                      p="lg"
                      onClick={() => setSelectedDistrict(district)}
                      style={{
                        cursor: "pointer",
                        background: "rgba(255,255,255,0.05)",
                        border: "1px solid rgba(255,255,255,0.08)",
                      }}
                    >
                      <Group justify="space-between">
                        <Box>
                          <Text fw={700} c="white">
                            {district}
                          </Text>

                          <Text size="xs" c="dimmed">
                            Court Directory
                          </Text>
                        </Box>

                        <ThemeIcon
                          radius="xl"
                          variant="light"
                          color="blue"
                        >
                          <IconArrowRight size={16} />
                        </ThemeIcon>
                      </Group>
                    </Paper>
                  ))}
                </SimpleGrid>
              </>
            )}

            {/* DETAILS */}
            {selectedCourt && selectedDistrict && (
              <>
                <Group mb="lg">
                  <Button
                    radius="xl"
                    variant="light"
                    color="gray"
                    onClick={() => setSelectedDistrict(null)}
                  >
                    ← Districts
                  </Button>

                  <Button
                    radius="xl"
                    variant="outline"
                    color="gray"
                    onClick={() => {
                      setSelectedDistrict(null);
                      setSelectedCourt(null);
                    }}
                  >
                    ← Courts
                  </Button>
                </Group>

                <Stack gap="md">
                  {Distcourt.filter(
                    (item) =>
                      item.selectsubdistcourt === selectedCourt &&
                      item.selectdist === selectedDistrict &&
                      (
                        item.Personname
                          ?.toLowerCase()
                          .includes(distsearchTerm.toLowerCase()) ||
                        item.designation
                          ?.toLowerCase()
                          .includes(distsearchTerm.toLowerCase()) ||
                        item.roomno
                          ?.toLowerCase()
                          .includes(distsearchTerm.toLowerCase()) ||
                        item.staffname
                          ?.toLowerCase()
                          .includes(distsearchTerm.toLowerCase())
                      )
                  ).map((item, index) => (
                    <Paper
                      key={index}
                      radius="26px"
                      p="lg"
                      style={{
                        background: "rgba(255,255,255,0.05)",
                        border: "1px solid rgba(255,255,255,0.08)",
                        backdropFilter: "blur(15px)",
                      }}
                    >
                      <Group justify="space-between" mb="md">
                        <Group>
                          <Avatar
                            radius="xl"
                            color="blue"
                          >
                            {item.Personname?.charAt(0)}
                          </Avatar>

                          <Box>
                            <Text fw={700} c="white">
                              {item.Personname}
                            </Text>

                            <Text size="sm" c="#94a3b8">
                              {item.designation}
                            </Text>
                          </Box>
                        </Group>

                        <Badge
                          radius="xl"
                          variant="gradient"
                          gradient={{
                            from: "indigo",
                            to: "cyan",
                          }}
                        >
                          Room {item.roomno}
                        </Badge>
                      </Group>

                      <SimpleGrid
                        cols={{ base: 1, sm: 2 }}
                        spacing="md"
                      >
                        <Paper
                          p="sm"
                          radius="xl"
                          bg="rgba(255,255,255,0.04)"
                        >
                          <Text size="xs" c="dimmed">
                            Staff Name
                          </Text>

                          <Text c="white" fw={600}>
                            {item.staffname || "N/A"}
                          </Text>
                        </Paper>

                        <Paper
                          p="sm"
                          radius="xl"
                          bg="rgba(255,255,255,0.04)"
                        >
                          <Text size="xs" c="dimmed">
                            Mobile Number
                          </Text>

                          <Text c="white" fw={600}>
                            {item.mobileno || "N/A"}
                          </Text>
                        </Paper>

                        <Paper
                          p="sm"
                          radius="xl"
                          bg="rgba(255,255,255,0.04)"
                        >
                          <Text size="xs" c="dimmed">
                            Email Address
                          </Text>

                          <Text c="white" fw={600}>
                            {item.emailid || "N/A"}
                          </Text>
                        </Paper>

                        <Paper
                          p="sm"
                          radius="xl"
                          bg="rgba(255,255,255,0.04)"
                        >
                          <Text size="xs" c="dimmed">
                            VC Access
                          </Text>

                          <Anchor
                            href={item.vclinks}
                            target="_blank"
                            underline="never"
                          >
                            <Button
                              radius="xl"
                              mt={4}
                              size="xs"
                              variant="gradient"
                              gradient={{
                                from: "blue",
                                to: "cyan",
                              }}
                              leftSection={
                                <IconVideo size={14} />
                              }
                            >
                              Join VC
                            </Button>
                          </Anchor>
                        </Paper>
                      </SimpleGrid>
                    </Paper>
                  ))}
                </Stack>
              </>
            )}
          </Tabs.Panel>

          {/* ================= HIGH COURT ================= */}

          <Tabs.Panel value="high">
            <TextInput
              radius="xl"
              size="md"
              placeholder="Search High Court details..."
              mt="sm"
              mb="lg"
              value={highsearchTerm}
              onChange={(e) =>
                setHighsearchTerm(e.currentTarget.value)
              }
              leftSection={<IconSearch size={16} />}
              styles={{
                input: {
                  background: "rgba(255,255,255,0.06)",
                  border: "1px solid rgba(255,255,255,0.08)",
                  color: "white",
                  height: 52,
                },
              }}
            />

            <Stack gap="md">
              {Highcourt.length > 0 ? (
                Highcourt.filter(
                  (item) =>
                    item.Personname
                      ?.toLowerCase()
                      .includes(highsearchTerm.toLowerCase()) ||
                    item.designation
                      ?.toLowerCase()
                      .includes(highsearchTerm.toLowerCase()) ||
                    item.roomno
                      ?.toLowerCase()
                      .includes(highsearchTerm.toLowerCase())
                ).map((item, index) => (
                  <Paper
                    key={index}
                    radius="24px"
                    p="lg"
                    style={{
                      background: "rgba(255,255,255,0.05)",
                      border: "1px solid rgba(255,255,255,0.08)",
                    }}
                  >
                    <Group justify="space-between">
                      <Box>
                        <Text fw={700} c="white">
                          {item.Personname}
                        </Text>
                        <Badge
                          radius="xl"
                          variant="gradient"
                          gradient={{
                            from: "indigo",
                            to: "cyan",
                          }}
                        >
                          Room {item.roomno}
                        </Badge>
                        <Text size="sm" c="#94a3b8">
                          {item.designation}
                        </Text>

                      </Box>
                      <Group>
                        <Paper
                          p="sm"
                          radius="xl"
                          bg="rgba(255,255,255,0.04)"
                        >
                          <Text size="xs" c="dimmed">
                            Email Address
                          </Text>

                          <Text c="white" fw={600}>
                            {item.emailid || "N/A"}
                          </Text>
                        </Paper>
                      </Group>

                      <Anchor
                        href={item.vclinks}
                        target="_blank"
                      >
                        <Button
                          radius="xl"
                          variant="gradient"
                          gradient={{
                            from: "indigo",
                            to: "cyan",
                          }}
                        >
                          Join VC
                        </Button>
                      </Anchor>
                    </Group>
                  </Paper>
                ))
              ) : loadinghighcourt ? (
                <Center mt="xl">
                  <Loader color="blue" />
                </Center>
              ) : (
                <Center mt="xl">
                  <Text c="dimmed">
                    No VC links available
                  </Text>
                </Center>
              )}
            </Stack>
          </Tabs.Panel>

          {/* ================= SUPREME COURT ================= */}

          <Tabs.Panel value="suprem">
            <TextInput
              radius="xl"
              size="md"
              placeholder="Search Supreme Court details..."
              mt="sm"
              mb="lg"
              value={supremsearchTerm}
              onChange={(e) =>
                setSupremsearchTerm(e.currentTarget.value)
              }
              leftSection={<IconSearch size={16} />}
              styles={{
                input: {
                  background: "rgba(255,255,255,0.06)",
                  border: "1px solid rgba(255,255,255,0.08)",
                  color: "white",
                  height: 52,
                },
              }}
            />

            <Stack gap="md">
              {Supremcourt.length > 0 ? (
                Supremcourt.filter(
                  (item) =>
                    item.Personname
                      ?.toLowerCase()
                      .includes(
                        supremsearchTerm.toLowerCase()
                      ) ||
                    item.designation
                      ?.toLowerCase()
                      .includes(
                        supremsearchTerm.toLowerCase()
                      ) || item.roomno
                        ?.toLowerCase()
                        .includes(
                          supremsearchTerm.toLowerCase()

                        )
                ).map((item, index) => (
                  <Paper
                    key={index}
                    radius="24px"
                    p="lg"
                    style={{
                      background: "rgba(255,255,255,0.05)",
                      border: "1px solid rgba(255,255,255,0.08)",
                    }}
                  >
                    <Group justify="space-between">
                      <Box>
                        <Text fw={700} c="white">
                          {item.Personname}
                        </Text>
                        <Badge
                          radius="xl"
                          variant="gradient"
                          gradient={{
                            from: "indigo",
                            to: "cyan",
                          }}
                        >
                          Room {item.roomno}
                        </Badge>
                        <Text size="sm" c="#94a3b8">
                          {item.designation}
                        </Text>
                      </Box>
                      <Anchor
                        href={item.vclinks}
                        target="_blank"
                      >
                        <Button
                          radius="xl"
                          variant="gradient"
                          gradient={{
                            from: "yellow",
                            to: "orange",
                          }}
                        >
                          Join VC
                        </Button>
                      </Anchor>
                    </Group>
                  </Paper>
                ))
              ) : loadingsupremcourt ? (
                <Center mt="xl">
                  <Loader color="yellow" />
                </Center>
              ) : (
                <Center mt="xl">
                  <Text c="dimmed">
                    No VC links available
                  </Text>
                </Center>
              )}
            </Stack>
          </Tabs.Panel>
        </Tabs>
      </Modal>
      <Modal // for Police Administration
        opened={activeModal === "FIR Details"}
        onClose={() => setActiveModal(null)}
        centered
        radius={24}
        size="xl"
        padding="lg"
        overlayProps={{
          blur: 12,
          backgroundOpacity: 0.65,
        }}
        styles={{
          content: {
            background:
              "linear-gradient(145deg, rgba(15,23,42,0.98), rgba(30,41,59,0.96))",
            border: "1px solid rgba(255,255,255,0.08)",
            backdropFilter: "blur(20px)",
            boxShadow: "0 20px 60px rgba(0,0,0,0.45)",
            //overflow: "hidden",
          },

          header: {
            // background: "transparent",
            background: "rgba(15,23,42,0.95)",
            borderBottom: "1px solid rgba(255,255,255,0.08)",
            paddingBottom: "14px",
          },

          title: {
            color: "white",
            fontWeight: 800,
            fontSize: "24px",
            letterSpacing: 0.5,
          },

          close: {
            color: "#cbd5e1",

            "&:hover": {
              background: "rgba(255,255,255,0.08)",
              color: "white",
            },
          },

          body: {
            paddingTop: "20px",
          },
        }}
        title={
          <Group gap={10}>
            <ThemeIcon
              radius="xl"
              size={42}
              variant="gradient"
              gradient={{ from: "blue", to: "cyan", deg: 90 }}
            >
              <IconShieldLock size={22} />
            </ThemeIcon>

            <Box>
              <Text fw={800} size="lg" c="white">
                FIR Details
              </Text>

              <Text size="xs" c="#94a3b8">
                FIR Information Portal
              </Text>
            </Box>
          </Group>
        }
      >
        {/* TOP INFO CARD */}
        <Paper
          radius="xl"
          p="md"
          mb="lg"
          style={{
            background: "rgba(255,255,255,0.05)",
            border: "1px solid rgba(255,255,255,0.08)",
            backdropFilter: "blur(10px)",
          }}
        >
          <Group align="flex-start" wrap="nowrap">
            <ThemeIcon
              size={42}
              radius="xl"
              variant="gradient"
              gradient={{ from: "blue", to: "cyan" }}
            >
              <IconScale size={20} />
            </ThemeIcon>

            <Box>
              <Text c="white" fw={700} mb={4}>
                Access Verified FIR Records
              </Text>

              <Text size="sm" c="#cbd5e1" lh={1.7}>
                Search, FIR related information,
                jurisdiction records and administrative data from one centralized
                legal platform.
              </Text>
            </Box>
          </Group>
        </Paper>

        {/* TABS */}
        <Box>
          <Newfirtable />
        </Box>

        {/* <Tabs
          defaultValue="policestation"
          variant="unstyled"
          styles={{
            list: {
              display: "flex",
              gap: "12px",
              marginBottom: "24px",
              flexWrap: "wrap",
            },

            tab: {
              background: "rgba(255,255,255,0.05)",
              border: "1px solid rgba(255,255,255,0.08)",
              color: "#cbd5e1",
              borderRadius: "14px",
              fontWeight: 700,
              height: "50px",
              paddingInline: "18px",
              transition: "all 0.25s ease",
              backdropFilter: "blur(12px)",

              "&:hover": {
                background: "rgba(255,255,255,0.12)",
                color: "white",
                border: "1px solid rgba(96,165,250,0.35)",
              },

              "&[data-active]": {
                background:
                  "linear-gradient(135deg, #2563eb 0%, #06b6d4 100%)",
                color: "white",
                border: "1px solid transparent",
                boxShadow: "0 10px 30px rgba(37,99,235,0.35)",
              },
            },

            panel: {
              paddingTop: "4px",
            },
          }}
        >
          <Tabs.List grow>
            <Tabs.Tab
              value="fir"
              leftSection={<IconFileDescription size={16} />}
              disabled
            >
              FIR Details
            </Tabs.Tab>

            <Tabs.Tab
              value="fir"
              leftSection={<IconFileDescription size={16} />}
            >
              FIR Details
            </Tabs.Tab>
          </Tabs.List>

          {/* POLICE STATION 
          <Tabs.Panel value="policestation">
            <Paper
              radius="xl"
              // p="md"
              style={{
                background: "rgba(255,255,255,0.04)",
                border: "1px solid rgba(255,255,255,0.06)",
                backdropFilter: "blur(10px)",
              }}
            >
              <Newfirtable />
            </Paper>
          </Tabs.Panel>

         FIR DETAILS 
          <Tabs.Panel value="fir">
            <Paper
              //radius="xl"
              // p="md"
              style={{
                background: "rgba(255,255,255,0.04)",
                border: "1px solid rgba(255,255,255,0.06)",
                backdropFilter: "blur(10px)",
              }}
            >
              
              <Newfirtable />
            </Paper>
          </Tabs.Panel>
        </Tabs> */}
      </Modal>
      <Modal // for Legal Drafts & Forms
        opened={activeModal === "Legal Drafts"}
        onClose={() => setActiveModal(null)}
        title={
          <Group gap="sm">
            <ThemeIcon
              radius="xl"
              size={38}
              variant="gradient"
              gradient={{ from: "blue", to: "cyan", deg: 90 }}
            >
              <FilePresentIcon size={20} />
            </ThemeIcon>

            <Box>
              <Text fw={700} size="lg" c="white">
                Legal Drafts & Forms
              </Text>
              <Text size="xs" c="dimmed">
                Access court drafts, petitions & legal documents
              </Text>
            </Box>
          </Group>
        }
        centered
        size="90%"
        radius="24px"
        padding="lg"
        overlayProps={{
          blur: 8,
          backgroundOpacity: 0.7,
        }}
        styles={{
          content: {
            background:
              "linear-gradient(135deg, #0f172a 0%, #111827 45%, #1e293b 100%)",
            border: "1px solid rgba(255,255,255,0.08)",
            color: "white",
            //overflow: "hidden",
          },

          header: {
            background: "rgba(15,23,42,0.95)",
            //background: "transparent",
            borderBottom: "1px solid rgba(255,255,255,0.08)",
            paddingBottom: 14,
          },

          title: {
            width: "100%",
          },

          body: {
            paddingTop: 20,
          },

          close: {
            color: "white",
            "&:hover": {
              background: "rgba(255,255,255,0.08)",
            },
          },
        }}
      >
        {/* SEARCH */}
        <Paper
          radius="xl"
          p="sm"
          mb="xl"
          style={{
            background: "rgba(255,255,255,0.04)",
            border: "1px solid rgba(255,255,255,0.08)",
            backdropFilter: "blur(10px)",
          }}
        >
          <TextInput
            radius="xl"
            size="md"
            placeholder="Search legal drafts, forms, courts..."
            value={filesearch}
            onChange={(e) => setfilesearch(e.currentTarget.value)}
            leftSection={<SearchIcon size={18} />}
            styles={{
              input: {
                background: "rgba(255,255,255,0.05)",
                border: "1px solid rgba(255,255,255,0.08)",
                color: "white",
                height: 50,
              },
            }}
          />
        </Paper>

        {/* MAIN COURT TABS */}
        <Tabs
          variant="unstyled"
          defaultValue="Dist. Court"
        >
          <Tabs.List grow mb="xl">
            {["Dist. Court", "High Court", "Supreme Court"].map((court) => (
              <Tabs.Tab
                key={court}
                value={court}
                style={{
                  background: "rgba(255,255,255,0.05)",
                  border: "1px solid rgba(255,255,255,0.08)",
                  color: "#cbd5e1",
                  borderRadius: 16,
                  padding: "14px 20px",
                  fontWeight: 700,
                  transition: "0.3s",
                  marginRight: 12,
                }}
              >
                {court}
              </Tabs.Tab>
            ))}
          </Tabs.List>

          {/* DISTRICT COURT */}
          <Tabs.Panel value="Dist. Court">
            <Tabs
              variant="unstyled"
              defaultValue="Misc forms"
            >
              <Tabs.List grow mb="lg">
                {["Misc forms", "Civil forms", "Criminal forms"].map((type) => (
                  <Tabs.Tab
                    key={type}
                    value={type}
                    style={{
                      background: "rgba(255,255,255,0.04)",
                      border: "1px solid rgba(255,255,255,0.08)",
                      color: "#e2e8f0",
                      borderRadius: 14,
                      padding: "12px",
                      fontWeight: 600,
                      marginRight: 12,
                    }}
                  >
                    {type}
                  </Tabs.Tab>
                ))}
              </Tabs.List>

              {["Misc forms", "Civil forms", "Criminal forms"].map((type) => (
                <Tabs.Panel key={type} value={type}>
                  <SimpleGrid cols={{ base: 1, md: 2 }} spacing="lg">
                    {miscfiles.length > 0 ? (
                      miscfiles
                        .filter(
                          (item) =>
                            item.court === "Dist. court" &&
                            item.formtype === type &&
                            (
                              item.subdistcourt
                                ?.toLowerCase()
                                .includes(filesearch.toLowerCase()) ||
                              item.UplaodingYear
                                .toLowerCase()
                                .includes(filesearch.toLowerCase()) ||
                              item.Miscforms
                                .toLowerCase()
                                .includes(filesearch.toLowerCase())
                            )
                        )
                        .map((item, index) => (
                          <Paper
                            key={index}
                            radius="24px"
                            p="lg"
                            style={{
                              background: "rgba(255,255,255,0.05)",
                              border: "1px solid rgba(255,255,255,0.08)",
                              backdropFilter: "blur(12px)",
                              transition: "0.3s",
                            }}
                          >
                            <Group justify="space-between" mb="md">
                              <Badge
                                variant="gradient"
                                gradient={{ from: "blue", to: "cyan" }}
                                radius="xl"
                              >
                                #{index + 1}
                              </Badge>

                              <ThemeIcon
                                size={42}
                                radius="xl"
                                variant="light"
                                color="blue"
                              >
                                <FilePresentIcon size={20} />
                              </ThemeIcon>
                            </Group>

                            <Stack gap={8}>
                              <Text c="white" fw={700}>
                                {item.formtype}
                              </Text>

                              <Text size="sm" c="#cbd5e1">
                                Court: {item.court}
                              </Text>

                              <Text size="sm" c="#cbd5e1">
                                District Court: {item.subdistcourt}
                              </Text>

                              <Text size="sm" c="#94a3b8">
                                Uploaded Year: {item.UplaodingYear}
                              </Text>
                            </Stack>

                            <Button
                              component="a"
                              // href={`https://cdr-backend.onrender.com/uploads/${item.Miscforms}`}
                              href={item.Miscforms}
                              target="_blank"
                              fullWidth
                              mt="lg"
                              radius="xl"
                              variant="gradient"
                              gradient={{ from: "blue", to: "cyan" }}
                            >
                              Download Draft
                            </Button>
                          </Paper>
                        ))
                    ) : loading ? (
                      <Center mt="xl">
                        <Loader color="blue" />
                      </Center>
                    ) : (
                      <Center mt="xl">
                        <Empty />
                      </Center>
                    )}
                  </SimpleGrid>
                </Tabs.Panel>
              ))}
            </Tabs>
          </Tabs.Panel>

          {/* HIGH COURT */}
          <Tabs.Panel value="High Court">
            <Tabs
              variant="unstyled"
              defaultValue="Misc forms"
            >
              <Tabs.List grow mb="lg">
                {["Misc forms", "Civil forms", "Criminal forms"].map((type) => (
                  <Tabs.Tab
                    key={type}
                    value={type}
                    style={{
                      background: "rgba(255,255,255,0.04)",
                      border: "1px solid rgba(255,255,255,0.08)",
                      color: "#e2e8f0",
                      borderRadius: 14,
                      padding: "12px",
                      fontWeight: 600,
                      marginRight: 12,
                    }}
                  >
                    {type}
                  </Tabs.Tab>
                ))}
              </Tabs.List>

              {["Misc forms", "Civil forms", "Criminal forms"].map((type) => (
                <Tabs.Panel key={type} value={type}>
                  <SimpleGrid cols={{ base: 1, md: 2 }} spacing="lg">
                    {miscfiles.length > 0 ? (
                      miscfiles
                        .filter(
                          (item) =>
                            item.court === "High court" &&
                            item.formtype === type &&
                            (
                              item.UplaodingYear
                                .toLowerCase()
                                .includes(filesearch.toLowerCase()) ||
                              item.Miscforms
                                .toLowerCase()
                                .includes(filesearch.toLowerCase())
                            )
                        )
                        .map((item, index) => (
                          <Paper
                            key={index}
                            radius="24px"
                            p="lg"
                            style={{
                              background: "rgba(255,255,255,0.05)",
                              border: "1px solid rgba(255,255,255,0.08)",
                            }}
                          >
                            <Group justify="space-between" mb="md">
                              <Badge
                                variant="gradient"
                                gradient={{ from: "indigo", to: "cyan" }}
                                radius="xl"
                              >
                                #{index + 1}
                              </Badge>

                              <ThemeIcon
                                size={42}
                                radius="xl"
                                variant="light"
                                color="indigo"
                              >
                                <GavelIcon size={20} />
                              </ThemeIcon>
                            </Group>

                            <Stack gap={8}>
                              <Text c="white" fw={700}>
                                {item.formtype}
                              </Text>

                              <Text size="sm" c="#cbd5e1">
                                Court: {item.court}
                              </Text>

                              <Text size="sm" c="#94a3b8">
                                Uploaded Year: {item.UplaodingYear}
                              </Text>
                            </Stack>

                            <Button
                              component="a"
                              // href={`https://cdr-backend.onrender.com/uploads/${item.Miscforms}`}
                              href={item.Miscforms}
                              target="_blank"
                              fullWidth
                              mt="lg"
                              radius="xl"
                              variant="gradient"
                              gradient={{ from: "indigo", to: "cyan" }}
                            >
                              Download Draft
                            </Button>
                          </Paper>
                        ))
                    ) : loading ? (
                      <Center mt="xl">
                        <Loader color="blue" />
                      </Center>
                    ) : (
                      <Center mt="xl">
                        <Empty />
                      </Center>
                    )}
                  </SimpleGrid>
                </Tabs.Panel>
              ))}
            </Tabs>
          </Tabs.Panel>

          {/* SUPREME COURT */}
          <Tabs.Panel value="Supreme Court">
            <Tabs
              variant="unstyled"
              defaultValue="Misc forms"
            >
              <Tabs.List grow mb="lg">
                {["Misc forms", "Civil forms", "Criminal forms"].map((type) => (
                  <Tabs.Tab
                    key={type}
                    value={type}
                    style={{
                      background: "rgba(255,255,255,0.04)",
                      border: "1px solid rgba(255,255,255,0.08)",
                      color: "#e2e8f0",
                      borderRadius: 14,
                      padding: "12px",
                      fontWeight: 600,
                      marginRight: 12,
                    }}
                  >
                    {type}
                  </Tabs.Tab>
                ))}
              </Tabs.List>

              {["Misc forms", "Civil forms", "Criminal forms"].map((type) => (
                <Tabs.Panel key={type} value={type}>
                  <SimpleGrid cols={{ base: 1, md: 2 }} spacing="lg">
                    {miscfiles.length > 0 ? (
                      miscfiles
                        .filter(
                          (item) =>
                            item.court === "Supreme court" &&
                            item.formtype === type &&
                            (
                              item.UplaodingYear
                                .toLowerCase()
                                .includes(filesearch.toLowerCase()) ||
                              item.Miscforms
                                .toLowerCase()
                                .includes(filesearch.toLowerCase())
                            )
                        )
                        .map((item, index) => (
                          <Paper
                            key={index}
                            radius="24px"
                            p="lg"
                            style={{
                              background: "rgba(255,255,255,0.05)",
                              border: "1px solid rgba(255,255,255,0.08)",
                            }}
                          >
                            <Group justify="space-between" mb="md">
                              <Badge
                                variant="gradient"
                                gradient={{ from: "grape", to: "pink" }}
                                radius="xl"
                              >
                                #{index + 1}
                              </Badge>

                              <ThemeIcon
                                size={42}
                                radius="xl"
                                variant="light"
                                color="grape"
                              >
                                <GavelIcon size={20} />
                              </ThemeIcon>
                            </Group>

                            <Stack gap={8}>
                              <Text c="white" fw={700}>
                                {item.formtype}
                              </Text>

                              <Text size="sm" c="#cbd5e1">
                                Court: {item.court}
                              </Text>

                              <Text size="sm" c="#94a3b8">
                                Uploaded Year: {item.UplaodingYear}
                              </Text>
                            </Stack>

                            <Button
                              component="a"
                              // href={`https://cdr-backend.onrender.com/uploads/${item.Miscforms}`}
                              href={item.Miscforms}
                              target="_blank"
                              fullWidth
                              mt="lg"
                              radius="xl"
                              variant="gradient"
                              gradient={{ from: "grape", to: "pink" }}
                            >
                              Download Draft
                            </Button>
                          </Paper>
                        ))
                    ) : loading ? (
                      <Center mt="xl">
                        <Loader color="blue" />
                      </Center>
                    ) : (
                      <Center mt="xl">
                        <Empty />
                      </Center>
                    )}
                  </SimpleGrid>
                </Tabs.Panel>
              ))}
            </Tabs>
          </Tabs.Panel>
        </Tabs>
      </Modal>
      <Modal // for Court claenders
        opened={activeModal === 'Court Calendar'}
        onClose={() => setActiveModal(null)}
        title={
          <Group gap="sm">
            <ThemeIcon
              radius="xl"
              size={38}
              variant="gradient"
              gradient={{ from: '#7C3AED', to: '#4F46E5' }}
            >
              <CalendarMonthIcon size={20} />
            </ThemeIcon>

            <Box>
              <Text fw={700} size="lg">
                Court Calendar
              </Text>
              <Text size="xs" c="dimmed">
                View & download yearly court calendars
              </Text>
            </Box>
          </Group>
        }
        centered
        radius="24px"
        size="lg"
        overlayProps={{
          blur: 7,
          backgroundOpacity: 0.55,
        }}
        styles={{
          content: {
            background:
              'linear-gradient(180deg, #0F172A 0%, #111827 100%)',
            border: '1px solid rgba(255,255,255,0.08)',
            color: 'white',
          },
          header: {
            background: "rgba(15,23,42,0.95)",
            // background: 'transparent',
            borderBottom: '1px solid rgba(255,255,255,0.08)',
          },
          title: {
            width: '100%',
          },
          body: {
            paddingTop: 16,
          },
        }}
      >
        {/* Top Banner */}
        <Paper
          radius="xl"
          p="md"
          mb="lg"
          style={{
            background:
              'linear-gradient(135deg, rgba(124,58,237,0.18), rgba(79,70,229,0.18))',
            border: '1px solid rgba(255,255,255,0.08)',
          }}
        >
          <Group justify="space-between" wrap="nowrap">
            <Box>
              <Text fw={700} size="md" c="white">
                📅 Court Holiday & Hearing Calendar
              </Text>

              <Text size="sm" c="gray.3" mt={4}>
                Access latest uploaded court calendars by year.
              </Text>
            </Box>

            <ThemeIcon
              size={50}
              radius="xl"
              variant="light"
              color="violet"
            >
              <CalendarMonthIcon size={28} />
            </ThemeIcon>
          </Group>
        </Paper>

        {/* Calendar List */}
        <ScrollArea h={500} offsetScrollbars>
          <Stack gap="md">
            {courtcalenders.length > 0 ? (
              courtcalenders.map((item, index) => (
                <Paper
                  key={index}
                  radius="xl"
                  p="lg"
                  style={{
                    background: 'rgba(255,255,255,0.03)',
                    border:
                      '1px solid rgba(255,255,255,0.08)',
                    backdropFilter: 'blur(10px)',
                    transition: '0.3s',
                  }}
                >
                  <Group
                    justify="space-between"
                    align="center"
                    wrap="nowrap"
                  >
                    {/* Left Details */}
                    <Group wrap="nowrap" align="flex-start">
                      <ThemeIcon
                        size={52}
                        radius="xl"
                        variant="gradient"
                        gradient={{
                          from: '#8B5CF6',
                          to: '#6366F1',
                        }}
                      >
                        <DescriptionIcon size={24} />
                      </ThemeIcon>

                      <Box>
                        <Badge
                          variant="light"
                          color="violet"
                          radius="xl"
                          mb={8}
                        >
                          Year {item.UplaodingYear}
                        </Badge>

                        <Text fw={600} size="xs" c="white">
                          {item.Courtcalenderimg
                            .split('/')
                            .pop()
                            .replace(/^\d+-/, '')}
                        </Text>

                        <Text
                          size="xs"
                          c="dimmed"
                          mt={4}
                        >
                          Court Calendar Document
                        </Text>
                      </Box>
                    </Group>

                    {/* Download Button */}
                    <Button
                      component="a"
                      // href={`https://cdr-backend.onrender.com/uploads/${item.Courtcalenderimg}`}
                      href={item.Courtcalenderimg}
                      target="_blank"
                      radius="xl"
                      variant="gradient"
                      gradient={{
                        from: '#7C3AED',
                        to: '#4F46E5',
                      }}
                      // leftSection={<DownloadIcon size={13} />}
                    >
                    <DownloadIcon size={13} />
                    </Button>
                  </Group>
                </Paper>
              ))
            ) : loading ? (
              <Center py="xl">
                <Stack align="center" gap="xs">
                  <Loader color="violet" />
                  <Text size="sm" c="dimmed">
                    Loading court calendars...
                  </Text>
                </Stack>
              </Center>
            ) : (
              <Center py="xl">
                <Stack align="center">
                  <Empty description="No Court Calendar Found" />
                </Stack>
              </Center>
            )}
          </Stack>
        </ScrollArea>
      </Modal>
      <Modal // for Display boards
        opened={activeModal === 'Display Boards'}
        onClose={() => setActiveModal(null)}
        title={
          <Group gap="sm">
            <ThemeIcon
              size={40}
              radius="xl"
              variant="gradient"
              gradient={{ from: '#7C3AED', to: '#4F46E5' }}
            >
              <DashboardIcon size={20} />
            </ThemeIcon>

            <Box>
              <Text fw={700} size="lg">
                Court Display Boards
              </Text>

              <Text size="xs" c="dimmed">
                Live court display board access
              </Text>
            </Box>
          </Group>
        }
        centered
        radius="24px"
        size="lg"
        overlayProps={{
          blur: 7,
          backgroundOpacity: 0.55,
        }}
        styles={{
          content: {
            background:
              'linear-gradient(180deg, #0F172A 0%, #111827 100%)',
            border: '1px solid rgba(255,255,255,0.08)',
          },
          header: {
            background: "rgba(15,23,42,0.95)",
            //background: 'transparent',
            borderBottom: '1px solid rgba(255,255,255,0.08)',
          },
          body: {
            paddingTop: 18,
          },
        }}
      >
        {/* Top Banner */}
        <Paper
          radius="xl"
          p="md"
          mb="lg"
          style={{
            background:
              'linear-gradient(135deg, rgba(124,58,237,0.18), rgba(79,70,229,0.18))',
            border: '1px solid rgba(255,255,255,0.08)',
          }}
        >
          <Group justify="space-between" wrap="nowrap">
            <Box>
              <Text fw={700} size="md" c="white">
                🖥️ Live Court Display Boards
              </Text>

              <Text size="sm" c="gray.3" mt={4}>
                Quickly access real-time display boards for hearings,
                court rooms & case status.
              </Text>
            </Box>

            <ThemeIcon
              size={52}
              radius="xl"
              variant="light"
              color="violet"
            >
              <TvIcon size={28} />
            </ThemeIcon>
          </Group>
        </Paper>

        {/* Display Board Cards */}
        <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="lg">
          {/* High Court */}
          <Paper
            radius="2xl"
            p={0}
            style={{
              overflow: 'hidden',
              background: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(255,255,255,0.08)',
              backdropFilter: 'blur(12px)',
              transition: '0.3s',
            }}
          >
            <Box pos="relative">
              <Image
                src={DelhiHighcourt}
                h={190}
                alt="Delhi High Court"
              />

              <Badge
                variant="filled"
                color="violet"
                radius="xl"
                pos="absolute"
                top={12}
                right={12}
              >
                HIGH COURT
              </Badge>
            </Box>

            <Box p="md">
              <Group justify="space-between" align="flex-start">
                <Box>
                  <Text fw={700} size="md" c="white">
                    Delhi High Court
                  </Text>

                  <Text size="xs" c="dimmed" mt={4}>
                    Live physical display board access
                  </Text>
                </Box>

                <ThemeIcon
                  radius="xl"
                  variant="light"
                  color="indigo"
                >
                  <GavelIcon size={18} />
                </ThemeIcon>
              </Group>

              <Button
                fullWidth
                mt="lg"
                radius="xl"
                variant="gradient"
                gradient={{ from: '#7C3AED', to: '#4F46E5' }}
                rightSection={<ArrowOutwardIcon size={16} />}
                onClick={() =>
                  window.open(
                    'https://delhihighcourt.nic.in/app/physical-display-board',
                    '_blank'
                  )
                }
              >
                Open Display Board
              </Button>
            </Box>
          </Paper>

          {/* Supreme Court */}
          <Paper
            radius="2xl"
            p={0}
            style={{
              overflow: 'hidden',
              background: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(255,255,255,0.08)',
              backdropFilter: 'blur(12px)',
              transition: '0.3s',
            }}
          >
            <Box pos="relative">
              <Image
                src={IndSupremecourt}
                h={190}
                alt="Supreme Court"
              />

              <Badge
                variant="filled"
                color="pink"
                radius="xl"
                pos="absolute"
                top={12}
                right={12}
              >
                SUPREME COURT
              </Badge>
            </Box>

            <Box p="md">
              <Group justify="space-between" align="flex-start">
                <Box>
                  <Text fw={700} size="md" c="white">
                    Supreme Court of India
                  </Text>

                  <Text size="xs" c="dimmed" mt={4}>
                    Access live display board instantly
                  </Text>
                </Box>

                <ThemeIcon
                  radius="xl"
                  variant="light"
                  color="pink"
                >
                  <AccountBalanceIcon size={18} />
                </ThemeIcon>
              </Group>

              <Button
                fullWidth
                mt="lg"
                radius="xl"
                variant="gradient"
                gradient={{ from: '#EC4899', to: '#8B5CF6' }}
                rightSection={<ArrowOutwardIcon size={16} />}
                onClick={() =>
                  window.open(
                    'https://wdb.sci.gov.in/display_original.php',
                    '_blank'
                  )
                }
              >
                Open Display Board
              </Button>
            </Box>
          </Paper>
        </SimpleGrid>

        {/* Bottom Info */}
        <Paper
          mt="lg"
          radius="xl"
          p="md"
          style={{
            background: 'rgba(255,255,255,0.03)',
            border: '1px solid rgba(255,255,255,0.08)',
          }}
        >
          <Group gap="sm" align="flex-start" wrap="nowrap">
            <ThemeIcon
              variant="light"
              color="yellow"
              radius="xl"
            >
              <InfoOutlinedIcon size={18} />
            </ThemeIcon>

            <Box>
              <Text size="sm" fw={600} c="white">
                Quick Tip
              </Text>

              <Text size="xs" c="dimmed" mt={4}>
                Display boards are updated directly from official
                court systems. Keep refreshing for latest updates.
              </Text>
            </Box>
          </Group>
        </Paper>
      </Modal>
      <Modal // For E court filing portal
        opened={activeModal === 'E-Filing'}
        onClose={() => setActiveModal(null)}
        title={
          <Group gap="sm">
            <ThemeIcon
              size={40}
              radius="xl"
              variant="gradient"
              gradient={{ from: '#7C3AED', to: '#4F46E5' }}
            >
              <FolderOpenIcon size={20} />
            </ThemeIcon>

            <Box>
              <Text fw={700} size="lg">
                E Court Filing Portal
              </Text>

              <Text size="xs" c="dimmed">
                Access official e-filing services
              </Text>
            </Box>
          </Group>
        }
        centered
        radius="24px"
        size="lg"
        overlayProps={{
          blur: 7,
          backgroundOpacity: 0.55,
        }}
        styles={{
          content: {
            background:
              'linear-gradient(180deg, #0F172A 0%, #111827 100%)',
            border: '1px solid rgba(255,255,255,0.08)',
          },
          header: {
            background: "rgba(15,23,42,0.95)",
            //background: 'transparent',
            borderBottom: '1px solid rgba(255,255,255,0.08)',
          },
          body: {
            paddingTop: 18,
          },
        }}
      >
        {/* Top Banner */}
        <Paper
          radius="xl"
          p="md"
          mb="lg"
          style={{
            background:
              'linear-gradient(135deg, rgba(124,58,237,0.18), rgba(79,70,229,0.18))',
            border: '1px solid rgba(255,255,255,0.08)',
          }}
        >
          <Group justify="space-between" wrap="nowrap">
            <Box>
              <Text fw={700} size="md" c="white">
                ⚖️ Official E-Filing Services
              </Text>

              <Text size="sm" c="gray.3" mt={4}>
                File cases online directly through official court portals.
              </Text>
            </Box>

            <ThemeIcon
              size={52}
              radius="xl"
              variant="light"
              color="violet"
            >
              <UploadFileIcon size={28} />
            </ThemeIcon>
          </Group>
        </Paper>

        {/* Filing Cards */}
        <Stack gap="lg">

          {/* District Court */}
          <Paper
            radius="2xl"
            p={0}
            style={{
              overflow: 'hidden',
              background: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(255,255,255,0.08)',
              backdropFilter: 'blur(12px)',
            }}
          >
            <Box pos="relative">
              <Image
                src={Delhidistrictcourts}
                h={190}
                alt="District Court"
              />

              <Badge
                variant="filled"
                color="blue"
                radius="xl"
                pos="absolute"
                top={12}
                right={12}
              >
                DISTRICT COURT
              </Badge>
            </Box>

            <Box p="md">
              <Group justify="space-between" align="flex-start">
                <Box>
                  <Text fw={700} size="md" c="white">
                    District Court E-Filing
                  </Text>

                  <Text size="xs" c="dimmed" mt={4}>
                    Delhi District Courts online filing portal
                  </Text>
                </Box>

                <ThemeIcon
                  radius="xl"
                  variant="light"
                  color="blue"
                >
                  <GavelIcon size={18} />
                </ThemeIcon>
              </Group>

              <Button
                fullWidth
                mt="lg"
                radius="xl"
                variant="gradient"
                gradient={{ from: '#2563EB', to: '#4F46E5' }}
                rightSection={<ArrowOutwardIcon size={16} />}
                onClick={() =>
                  window.open(
                    'https://filing.ecourts.gov.in/pdedev/',
                    '_blank'
                  )
                }
              >
                Open E-Filing Portal
              </Button>
            </Box>
          </Paper>

          {/* High Court */}
          <Paper
            radius="2xl"
            p={0}
            style={{
              overflow: 'hidden',
              background: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(255,255,255,0.08)',
              backdropFilter: 'blur(12px)',
            }}
          >
            <Box pos="relative">
              <Image
                src={DelhiHighcourt}
                h={190}
                alt="Delhi High Court"
              />

              <Badge
                variant="filled"
                color="violet"
                radius="xl"
                pos="absolute"
                top={12}
                right={12}
              >
                HIGH COURT
              </Badge>
            </Box>

            <Box p="md">
              <Group justify="space-between" align="flex-start">
                <Box>
                  <Text fw={700} size="md" c="white">
                    Delhi High Court E-Filing
                  </Text>

                  <Text size="xs" c="dimmed" mt={4}>
                    Official Delhi High Court filing service
                  </Text>
                </Box>

                <ThemeIcon
                  radius="xl"
                  variant="light"
                  color="violet"
                >
                  <AccountBalanceIcon size={18} />
                </ThemeIcon>
              </Group>

              <Button
                fullWidth
                mt="lg"
                radius="xl"
                variant="gradient"
                gradient={{ from: '#7C3AED', to: '#4F46E5' }}
                rightSection={<ArrowOutwardIcon size={16} />}
                onClick={() =>
                  window.open(
                    'https://dhcefiling.nic.in/eFiling/',
                    '_blank'
                  )
                }
              >
                Open E-Filing Portal
              </Button>
            </Box>
          </Paper>

          {/* Supreme Court */}
          <Paper
            radius="2xl"
            p={0}
            style={{
              overflow: 'hidden',
              background: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(255,255,255,0.08)',
              backdropFilter: 'blur(12px)',
            }}
          >
            <Box pos="relative">
              <Image
                src={IndSupremecourt}
                h={190}
                alt="Supreme Court"
              />

              <Badge
                variant="filled"
                color="pink"
                radius="xl"
                pos="absolute"
                top={12}
                right={12}
              >
                SUPREME COURT
              </Badge>
            </Box>

            <Box p="md">
              <Group justify="space-between" align="flex-start">
                <Box>
                  <Text fw={700} size="md" c="white">
                    Supreme Court E-Filing
                  </Text>

                  <Text size="xs" c="dimmed" mt={4}>
                    Online filing portal for Supreme Court matters
                  </Text>
                </Box>

                <ThemeIcon
                  radius="xl"
                  variant="light"
                  color="pink"
                >
                  <BalanceIcon size={18} />
                </ThemeIcon>
              </Group>

              <Button
                fullWidth
                mt="lg"
                radius="xl"
                variant="gradient"
                gradient={{ from: '#EC4899', to: '#8B5CF6' }}
                rightSection={<ArrowOutwardIcon size={16} />}
                onClick={() =>
                  window.open(
                    'https://efiling.sci.gov.in/',
                    '_blank'
                  )
                }
              >
                Open E-Filing Portal
              </Button>
            </Box>
          </Paper>
        </Stack>

        {/* Bottom Info */}
        <Paper
          mt="lg"
          radius="xl"
          p="md"
          style={{
            background: 'rgba(255,255,255,0.03)',
            border: '1px solid rgba(255,255,255,0.08)',
          }}
        >
          <Group gap="sm" align="flex-start" wrap="nowrap">
            <ThemeIcon
              variant="light"
              color="yellow"
              radius="xl"
            >
              <InfoOutlinedIcon size={18} />
            </ThemeIcon>

            <Box>
              <Text size="sm" fw={600} c="white">
                Important Notice
              </Text>

              <Text size="xs" c="dimmed" mt={4}>
                Use valid advocate/client credentials before filing.
                Keep documents scanned in PDF format for smooth filing.
              </Text>
            </Box>
          </Group>
        </Paper>
      </Modal>
      <Modal // For External links
        opened={activeModal === 'External Links'}
        onClose={() => setActiveModal(null)}
        title={
          <Group gap="xs">
            <LinkIcon style={{ color: '#7c3aed' }} />
            <div>
              <Text fw={700} size="lg">
                External Links
              </Text>
              <Text size="xs" c="dimmed">
                Useful legal and government portal links
              </Text>
            </div>
          </Group>
        }
        size="xl"
        centered
        radius="xl"
        overlayProps={{
          blur: 7,
          backgroundOpacity: 0.55,
        }}
        styles={{
          content: {
            background:
              'linear-gradient(180deg, #0F172A 0%, #111827 100%)',
            border: '1px solid rgba(255,255,255,0.08)',
          },
          header: {
            background: "rgba(15,23,42,0.95)",
            //background: 'transparent',
            borderBottom: '1px solid rgba(255,255,255,0.08)',
          },
          body: {
            paddingTop: 18,
          },
        }}
      >
        <Stack mt="xs">

          <Paper
            p="md"
            radius="xl"
            mb="sm"
            style={{
              background:
                'linear-gradient(135deg, rgba(124,58,237,0.18), rgba(79,70,229,0.18))',
              border: '1px solid rgba(255,255,255,0.08)',
            }}
          // style={{
          //   background: 'linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%)',
          //   border: '1px solid #e0e7ff'
          // }}
          >
            <Group justify="space-between" align="center">
              <Group gap="sm">
                <ThemeIcon
                  size={50}
                  radius="xl"
                  variant="light"
                  color="violet"
                >
                  <LanguageIcon />
                </ThemeIcon>

                <div>
                  <Text fw={700} size="md">
                    Legal External Resources
                  </Text>

                  <Text size="xs" c="dimmed">
                    Open useful external legal and judicial portals
                  </Text>
                </div>
              </Group>

              <Badge
                color="violet"
                variant="light"
                radius="sm"
              >
                {extdata.length} Links
              </Badge>
            </Group>
          </Paper>

          <ScrollArea h={500} offsetScrollbars>

            {
              extdata.length > 0 ? (
                <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">

                  {extdata.map((item, index) => (
                    <Card
                      key={index}
                      shadow="sm"
                      radius="xl"
                      p="lg"
                      withBorder
                      style={{
                        background:
                          'linear-gradient(135deg, #ffffff 0%, #f9fafb 100%)',
                        border: '1px solid #ececec',
                        transition: '0.3s',
                      }}
                    >

                      <Group justify="space-between" align="flex-start">

                        <ThemeIcon
                          size={55}
                          radius="xl"
                          variant="light"
                          color="indigo"
                        >
                          <LinkIcon />
                        </ThemeIcon>

                        <Badge
                          color="green"
                          variant="light"
                          radius="sm"
                        >
                          Active
                        </Badge>
                      </Group>

                      <Stack gap={6} mt="md">

                        <Text
                          fw={700}
                          size="md"
                          lineClamp={2}
                          tt="capitalize"
                        >
                          {item.Extlinkname}
                        </Text>

                        <Text
                          size="xs"
                          c="dimmed"
                          lineClamp={2}
                        >
                          External legal reference and useful portal access.
                        </Text>

                      </Stack>

                      <Divider my="md" />

                      <Button
                        fullWidth
                        radius="xl"
                        size="md"
                        variant="gradient"
                        gradient={{ from: 'indigo', to: 'cyan' }}
                        rightSection={<OpenInNewIcon size={16} />}
                        onClick={() =>
                          window.open(item.Extlink, "_blank")
                        }
                      >
                        Open External Link
                      </Button>

                    </Card>
                  ))}

                </SimpleGrid>
              ) : loadingextlinks ? (
                <Center py="xl">
                  <Stack align="center" gap="xs">
                    <Loader color="indigo" />
                    <Text size="sm" c="dimmed">
                      Loading External Links...
                    </Text>
                  </Stack>
                </Center>
              ) : (
                <Center py="xl">
                  <Stack align="center">
                    <Empty />
                    <Text size="sm" c="dimmed">
                      No external links available
                    </Text>
                  </Stack>
                </Center>
              )
            }

          </ScrollArea>
        </Stack>
      </Modal>
      <Modal // For Profile details
        opened={profileModal}
        onClose={() => setProfileModal(false)}
        centered
        size="md"
        radius="30px"
        overlayProps={{
          blur: 10,
          backgroundOpacity: 0.55,
        }}
        title={
          <Text fw={700} size="lg">
            Legal Professional Details
          </Text>
        }
      >
        {selectedProfile && (
          <Stack>

            {/* TOP PROFILE */}
            <Group wrap="nowrap" align="flex-start">

              <Avatar
                size={80}
                radius="100%"
                color="blue"
                name={selectedProfile?.Fullname}
              />

              <Box>

                <Text fw={700} size="xl">
                  {selectedProfile?.Fullname}
                </Text>

                <Text c="dimmed">
                  {selectedProfile?.clerkid ? 'Clerk' : 'Advocate'}
                </Text>

                {/* <Badge
                  mt="xs"
                  color={
                    selectedProfile?.AccountType === 'Premium'
                      ? 'yellow'
                      : 'gray'
                  }
                  variant="light"
                >
                  {selectedProfile?.AccountType}
                </Badge> */}

              </Box>

            </Group>

            <Divider />

            {/* PERSONAL DETAILS */}
            <Box>

              <Text fw={700} mb="sm">
                Personal Details
              </Text>

              <Stack gap="xs">

                {/* PHONE */}
                <Group justify="space-between">
                  <Text c="dimmed">Phone</Text>

                  {
                    userDetails?.AccountType === 'Freemium'
                      ? (
                        <Text fw={600}>
                          {selectedProfile?.PhoneNumber}
                        </Text>
                      )
                      : (
                        <Group gap={4}>
                          <Text
                            fw={600}
                            style={{
                              filter: "blur(5px)",
                              userSelect: "none",
                            }}
                          >
                            {!isMobile && selectedProfile?.PhoneNumber}
                          </Text>

                          <Text>🔒</Text>
                        </Group>
                      )
                  }
                </Group>

                {/* EMAIL */}
                <Group justify="space-between">
                  <Text c="dimmed">Email</Text>

                  {
                    selectedProfile?.AccountType === 'Freemium'
                      ? (
                        <Text fw={600}>
                          {selectedProfile?.Email}
                        </Text>
                      )
                      : (
                        <Group gap={4}>
                          <Text
                            fw={600}
                            style={{
                              filter: "blur(5px)",
                              userSelect: "none",
                            }}
                          >
                            {!isMobile && selectedProfile?.Email}
                          </Text>

                          <Text>🔒</Text>
                        </Group>
                      )
                  }
                </Group>

                {/* ADDRESS */}
                <Group justify="space-between" align="flex-start">
                  <Text c="dimmed">Office Address</Text>

                  {
                    selectedProfile?.AccountType === 'Freemium'
                      ? (
                        <Text
                          fw={600}
                          ta="right"
                          maw={250}
                        >
                          {selectedProfile?.officeaddress || 'N/A'}
                        </Text>
                      )
                      : (
                        <Group gap={4}>
                          <Text
                            fw={600}
                            ta="right"
                            maw={220}
                            style={{
                              filter: "blur(5px)",
                              userSelect: "none",
                            }}
                          >
                            {!isMobile && selectedProfile?.officeaddress}
                          </Text>

                          <Text>🔒</Text>
                        </Group>
                      )
                  }
                </Group>

                <Group justify="space-between">
                  <Text c="dimmed">City</Text>

                  <Text fw={600}>
                    {selectedProfile?.city || 'N/A'}
                  </Text>
                </Group>

                <Group justify="space-between">
                  <Text c="dimmed">State</Text>

                  <Text fw={600}>
                    {selectedProfile?.state || 'N/A'}
                  </Text>
                </Group>

              </Stack>

            </Box>

            <Divider />

            {/* PROFESSIONAL DETAILS */}
            <Box>

              <Text fw={700} mb="sm">
                Professional Details
              </Text>

              <Stack gap="xs">

                <Group justify="space-between">
                  <Text c="dimmed">Bar Council No.</Text>

                  <Text fw={600}>
                    {selectedProfile?.barcouncilnumber || 'N/A'}
                  </Text>
                </Group>

                <Group justify="space-between">
                  <Text c="dimmed">Practice Court</Text>

                  <Text fw={600}>
                    {selectedProfile?.practicecourt || 'N/A'}
                  </Text>
                </Group>

                <Group justify="space-between">
                  <Text c="dimmed">Experience</Text>

                  <Text fw={600}>
                    {selectedProfile?.experience || '0 Years'}
                  </Text>
                </Group>

                <Group justify="space-between">
                  <Text c="dimmed">Specialization</Text>

                  <Text fw={600}>
                    {selectedProfile?.specialization || 'N/A'}
                  </Text>
                </Group>

                <Group justify="space-between">
                  <Text c="dimmed">Court Name</Text>

                  <Text fw={600}>
                    {selectedProfile?.courtname || 'N/A'}
                  </Text>
                </Group>

                <Group justify="space-between">
                  <Text c="dimmed">Department</Text>

                  <Text fw={600}>
                    {selectedProfile?.departmentsection || 'N/A'}
                  </Text>
                </Group>

                {
                  selectedProfile?.clerkid && (
                    <Group justify="space-between">
                      <Text c="dimmed">Clerk ID</Text>

                      <Text fw={600}>
                        {selectedProfile?.clerkid}
                      </Text>
                    </Group>
                  )
                }

                {
                  selectedProfile?.workingunder && (
                    <Group justify="space-between">
                      <Text c="dimmed">Working Under</Text>

                      <Text fw={600}>
                        {selectedProfile?.workingunder}
                      </Text>
                    </Group>
                  )
                }

              </Stack>

            </Box>

            {/* {
              selectedProfile?.AccountType === 'Freemium' && (
                <Paper
                  p="md"
                  radius="xl"
                  bg="rgba(255,215,0,0.08)"
                  style={{
                    border: "1px solid rgba(255,215,0,0.25)",
                  }}
                >
                  <Text size="sm" ta="center">
                    🔓 Upgrade to Premium to unlock contact details.
                  </Text>
                </Paper>
              )
            } */}

          </Stack>
        )}
      </Modal>
      <Modal // For Legal update details
        opened={legalUpdateModal}
        onClose={() => setLegalUpdateModal(false)}
        centered
        size="lg"
        radius="30px"
        title={
          <Group gap="sm">
            <ActionIcon
              variant="light"
              color="yellow"
              radius="xl"
            >
              <IconGavel size={18} />
            </ActionIcon>

            <Text fw={700}>
              Legal Update Details
            </Text>
          </Group>
        }
        styles={{
          content: {
            background:
              "linear-gradient(135deg,#0f172a 0%,#111827 100%)",
            border: "1px solid rgba(255,255,255,0.08)",
          },
          header: {
            background: "rgba(15,23,42,0.95)",
            borderBottom: '1px solid rgba(255,255,255,0.08)',
            //background: "transparent",
          },
        }}
      >
        {selectedLegalUpdate && (
          <Stack>

            <Group justify="space-between">

              <Badge
                size="lg"
                variant="light"
                color="yellow"
              >
                {selectedLegalUpdate.category}
              </Badge>

              <Text size="sm" c="dimmed">
                {new Date(
                  selectedLegalUpdate.createdAt
                ).toLocaleDateString()}
              </Text>

            </Group>

            {selectedLegalUpdate.subdistcourt &&
              selectedLegalUpdate.category ===
              "District Court" && (
                <Paper
                  p="sm"
                  radius="md"
                  bg="rgba(255,255,255,0.05)"
                >
                  <Text c="white">
                    <b>Sub District Court:</b>{" "}
                    {selectedLegalUpdate.subdistcourt}
                  </Text>
                </Paper>
              )}

            <Title order={3} c="white">
              {selectedLegalUpdate.title}
            </Title>

            <Text c="#94a3b8">
              {selectedLegalUpdate.shortdescription}
            </Text>

            <Divider />

            {/* Jodit HTML Content */}
            <Box
              style={{
                color: "#e2e8f0",
                lineHeight: 1.8,
              }}
              dangerouslySetInnerHTML={{
                __html: selectedLegalUpdate.content,
              }}
            />

          </Stack>
        )}
      </Modal>

      <Box
        style={{
          minHeight: "100vh",
          background:
            "linear-gradient(135deg,#020617 0%,#0f172a 40%,#111827 100%)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* BACKGROUND GLOW */}
        <Box
          style={{
            position: "absolute",
            width: 500,
            height: 500,
            borderRadius: "50%",
            background: "rgba(59,130,246,0.15)",
            filter: "blur(120px)",
            top: -100,
            right: -100,
          }}
        />

        <Box
          style={{
            position: "absolute",
            width: 400,
            height: 400,
            borderRadius: "50%",
            background: "rgba(168,85,247,0.15)",
            filter: "blur(120px)",
            bottom: -100,
            left: -100,
          }}
        />

        {/* MAIN CONTENT */}
        <Box
          px={{ base: "md", md: "xl" }}
          py={{ base: "md", md: "lg" }}
          style={{
            position: "relative",
            zIndex: 10,
            paddingBottom: 100,
          }}
        >
          {/* HEADER */}
          <Newnavbar />

          {/* SERVICES */}
          <Group justify="space-between" mb="md">
            <Title order={3} c="white">
              Quick Services
            </Title>

            <Badge
              variant="light"
              color="blue"
              radius="xl"
              size="lg"
            >
              8 Services
            </Badge>
          </Group>

          <SimpleGrid cols={{ base: 2, sm: 2, md: 4 }} spacing="lg">
            {services.map((item, index) => (
              <Card
                key={index}
                radius="30px"
                p="lg"
                style={{
                  background: "rgba(255,255,255,0.08)",
                  border: "1px solid rgba(255,255,255,0.08)",
                  backdropFilter: "blur(18px)",
                  cursor: "pointer",
                  transition: "0.3s",
                }}
                onClick={() => setActiveModal(item.title)}
              >
                <Stack align="center" gap="sm">
                  <Center
                    style={{
                      width: 65,
                      height: 65,
                      borderRadius: "100%",
                      background: `${item.color}20`,
                      color: item.color,
                    }}
                  >
                    {item.icon}
                  </Center>

                  <Text
                    ta="center"
                    fw={600}
                    style={{
                      color: "white",
                    }}
                  >
                    {item.title}
                  </Text>
                </Stack>
              </Card>
            ))}
          </SimpleGrid>

          {/* QUICK ACTIONS */}
          <Title order={3} c="white" mt={40} mb="md">
            Quick Access
          </Title>

          <SimpleGrid cols={{ base: 2, md: 4 }} spacing="lg">
            {[
              {
                title: "Alert History",
                icon: <IconHistory size={24} />,
                link: () => window.location.href = '/cdr/alert-history'
              },
              {
                title: "About Us",
                icon: <IconInfoCircle size={24} />,
                link: () => window.location.href = '/cdr/about'
              },
              {
                title: "Support",
                icon: <IconMessage2 size={24} />,
                link: () => window.location.href = '/v2/feedback-support'
              },
              {
                title: "Your Profile",
                icon: <IconUser size={24} />,
                link: () => window.location.href = '/v2/profile'
              },
            ].map((item, index) => (
              <Paper
                key={index}
                radius="25px"
                p="lg"
                onClick={item.link}
                style={{
                  background: "rgba(255,255,255,0.07)",
                  border: "1px solid rgba(255,255,255,0.08)",
                  backdropFilter: "blur(18px)",
                  cursor: "pointer",
                  transition: "0.3s",
                }}
              >
                <Group>
                  <ActionIcon
                    variant="light"
                    radius="xl"
                    size={45}
                    color="blue"
                  >
                    {item.icon}
                  </ActionIcon>

                  <Text fw={600} c="white">
                    {item.title}
                  </Text>
                </Group>
              </Paper>
            ))}
          </SimpleGrid>

          {/* PROFESSIONALS */}
          <Group justify="space-between" mt={45} mb="md">
            <Title order={3} c="white">
              Legal Professionals
            </Title>

            <Button radius="xl" variant="light" onClick={() => window.location.href = "/v2/view-all-legal-professionals"}>
              View All
            </Button>
          </Group>

          <Swiper
            modules={[Navigation]}
            navigation={isMobile ? false : true}
            spaceBetween={12}
            slidesPerView={1.08}
            style={{
              paddingTop: "10px",
              paddingBottom: "10px",
            }}
            breakpoints={{
              640: {
                slidesPerView: 1.8,
              },
              768: {
                slidesPerView: 2.2,
              },
              1024: {
                slidesPerView: 3,
              },
            }}
            onReachEnd={() => {

              if (hasMore && !legalprofilesloading) {

                const nextPage = page + 1;

                v2_getUserprofiles(nextPage);
              }
            }}
          >

            {legaluserprofiles.map((item, index) => (

              <SwiperSlide key={item._id}>

                <Paper
                  radius="30px"
                  p="xl"
                  h={'auto'}
                  style={{
                    background: "rgba(255,255,255,0.08)",
                    border: "1px solid rgba(255,255,255,0.08)",
                    backdropFilter: "blur(20px)",
                    overflow: "hidden",
                  }}
                >

                  <Stack h="100%" justify="space-between">

                    <Box>

                      <Group justify="space-between" align="flex-start">

                        <Group gap="sm" wrap="nowrap">

                          <Avatar
                            size={30}
                            radius="xl"
                            color="blue"
                            name={item?.Fullname}
                          />

                          <Box>
                            <Text
                              fw={700}
                              c="white"
                              lineClamp={1}
                            >
                              {item?.Fullname}
                            </Text>

                            <Text size="sm" c="#94a3b8">
                              {item?.clerkid ? 'Clerk' : 'Advocate'}
                            </Text>
                          </Box>

                        </Group>

                        <Badge
                          color="yellow"
                          variant="light"
                          style={{
                            maxWidth: 100,
                          }}
                        >
                          ⭐️ {item?.specialization || 'Legal'}
                        </Badge>

                      </Group>

                      <Divider
                        my="md"
                        color="rgba(255,255,255,0.08)"
                      />

                      <Group justify="space-between">
                        <Text size="sm" c="#94a3b8">
                          Experience
                        </Text>

                        <Text size="sm" fw={600} c="white">
                          ⚡️ {item?.experience || '0 Years'}
                        </Text>
                      </Group>

                    </Box>

                    <Button
                      radius="xl"
                      variant="gradient"
                      gradient={{ from: "blue", to: "cyan" }}
                      fullWidth
                      mt={'lg'}
                      onClick={() => OpenProfileDetails(item)}
                    >
                      View Full Details
                    </Button>

                  </Stack>

                </Paper>

              </SwiperSlide>

            ))}
          </Swiper>

          {/* LEGAL UPDATES */}
          <Group justify="space-between" mt={45} mb="md">
            <Title order={3} c="white" mb="md">
              Latest Legal Updates
            </Title>

            <Button radius="xl" variant="light" onClick={() => window.location.href = "/v2/view-all-legal-updates"}>
              View All
            </Button>
          </Group>


          <Grid>
            {legalupdates.map((item) => (
              <Grid.Col span={{ base: 12, md: 6 }} key={item}>
                <Paper
                  radius="30px"
                  p="xl"
                  style={{
                    background: "rgba(255,255,255,0.08)",
                    border: "1px solid rgba(255,255,255,0.08)",
                    backdropFilter: "blur(18px)",
                  }}
                >
                  <Group mb="md">
                    <ActionIcon
                      variant="light"
                      color="yellow"
                      radius="xl"
                      size={50}
                    >
                      <IconGavel size={24} />
                    </ActionIcon>

                    <Box>
                      <Group gap={5}>
                        <Text fw={700} c="white">
                          {item?.category}
                        </Text>

                        {item?.category === "District Court" && item?.subdistcourt && (
                          <Text size="sm" c="dimmed">
                            • {item.subdistcourt}
                          </Text>
                        )}
                      </Group>
                      <Text size="sm" c="#94a3b8">
                        {new Date(item.createdAt)
                          .toLocaleDateString()}
                      </Text>
                    </Box>
                  </Group>

                  <Text c="#cbd5e1" size="sm">
                    {item?.title}
                  </Text>
                  <Text c="#cbd5e1" size="sm">
                    {item?.shortdescription}
                  </Text>

                  <Button
                    mt="lg"
                    radius="xl"
                    variant="light"
                    color="blue"
                    onClick={() => OpenLegalUpdateModal(item)}
                  >
                    Read More
                  </Button>
                </Paper>
              </Grid.Col>
            ))}
          </Grid>

          {/* FOOTER */}
          <Paper
            radius="30px"
            p="xl"
            mt={50}
            style={{
              background: "rgba(255,255,255,0.06)",
              border: "1px solid rgba(255,255,255,0.08)",
              backdropFilter: "blur(18px)",
            }}
          >
            <Stack align="center" gap={4}>
              <Image
                src={CdrLogo}
                w={70}
                h={70}
                fit="contain"
              />

              <Title order={4} c="white">
                Court Date Reminder
              </Title>

              <Text ta="center" c="#94a3b8" maw={700}>
                Smart Legal Management Platform for Lawyers, Clients,
                Judges and Court Staff with alerts, VC links, legal
                drafts and more.
              </Text>

              <Divider
                w="100%"
                my="md"
                color="rgba(255,255,255,0.08)"
              />

              <Group justify="space-between" w="100%">
                <Stack gap={0}>
                  <Text size="xs" c="#94a3b8">
                    Founded By
                  </Text>

                  <Text size="sm" fw={700} c="white">
                    Adv. Abhiraj Yadav
                  </Text>
                </Stack>

                <Stack gap={0} align={isMobile ? 'flex-start' : 'flex-end'}>
                  <Text size="xs" c="#94a3b8">
                    Designed & Maintained
                  </Text>

                  <Text size="sm" fw={700} c="#60a5fa">
                    GV InfoTech.org
                  </Text>
                </Stack>
              </Group>
            </Stack>
          </Paper>
        </Box>

        {/* BOTTOM NAVIGATION */}
        <Box
          hiddenFrom="md"
          style={{
            position: "fixed",
            bottom: 15,
            left: 15,
            right: 15,
            zIndex: 100,
          }}
        >
          <Paper
            radius="30px"
            px="xl"
            py="md"
            style={{
              background: "rgba(15,23,42,0.9)",
              border: "1px solid rgba(255,255,255,0.08)",
              backdropFilter: "blur(20px)",
            }}
          >
            <Group justify="space-between">
              <Stack gap={2} align="center">
                <IconHome size={22} color="#60a5fa" onClick={() => window.location.href = "/v2/home"} />
                <Text size="xs" c="#60a5fa">
                  Home
                </Text>
              </Stack>

              <Stack gap={2} align="center">
                <IconBell size={22} color="white" onClick={() => window.location.href = "/cdr/alert-history"} />
                <Text size="xs" c="white">
                  Alerts
                </Text>
              </Stack>

              <Stack gap={2} align="center">
                <IconInfoCircle size={22} color="white" onClick={() => window.location.href = "/cdr/about"} />
                <Text size="xs" c="white">
                  About
                </Text>
              </Stack>

              <Stack gap={2} align="center">
                <IconUser size={22} color="white" onClick={() => window.location.href = "/v2/profile"} />
                <Text size="xs" c="white">
                  Profile
                </Text>
              </Stack>
            </Group>
          </Paper>
        </Box>
      </Box>
    </>
  );
}

